/* tslint:disable */
/* eslint-disable */
/**
 * Digiseg API
 * ### Digiseg API documentation  # Introduction  This API let you harness the power of Digisegs powerful and tracking-free segmentation engine.  Audiences by Digiseg are available in 50+ countries, probablistically mapping neighborhood characteristics to the IP addresses observed on the internet - Household targeting & measurement for the post-cookie world.  ## Developer SDKs  In addition to using these APIs directly through any HTTP client, we provide a set of API client SDKs for popular programming languages:  <div class=\"api-clients\">   <a class=\"api-client-box\" href=\"https://github.com/digiseg-labs/api-client-python\">     <i class=\"api-client-sdk-logo devicon-python-plain\"></i>     <p>API client for Python</p>   </a>   <a class=\"api-client-box\" href=\"https://github.com/digiseg-labs/api-client-ts\">     <i class=\"api-client-sdk-logo devicon-typescript-plain\"></i>     <p>API client for TypeScript</p>   </a>   <a class=\"api-client-box\" href=\"https://github.com/digiseg-labs/api-client-go\">     <i class=\"api-client-sdk-logo devicon-go-original-wordmark\"></i>     <p>API client for Go</p>   </a> </div> <div class=\"api-clients-breaker\" />
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@digiseg.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, operationServerMap } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export const AccountIncludeParam = {
    None: 'none',
    Subscriptions: 'subscriptions'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountSortOption = {
    CreatedAt: 'created_at',
    CreatedAt2: '-created_at',
    Name: 'name',
    Name2: '-name'
};
export const AccountSubscriptionPaymentConfigurationPlatformEnum = {
    Stripe: 'stripe',
    Manual: 'manual'
};
export const AccountSubscriptionPaymentConfigurationTimingEnum = {
    Pre: 'pre',
    Post: 'post'
};
/**
 * Describes the status of the API key. The status can be set to active or disabled manually. It will become expired automatically, if the expiry date has been surpassed.
 * @export
 * @enum {string}
 */
export const ApiKeyStatus = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    Expired: 'expired'
};
/**
 * Describes the result of resolving the audiences of an IP address. `resolved` means that the IP was resolved and audiences are returned. `unresolved` means that the IP could not be resolved and no audiences are returned. `forbidden` means that the authenticated user did not have grants to resolve audiences in the country of the IP.
 * @export
 * @enum {string}
 */
export const AudienceResponseStatus = {
    Resolved: 'resolved',
    Unresolved: 'unresolved',
    Forbidden: 'forbidden'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AudiencesIncludeParam = {
    Core: 'core',
    Composite: 'composite',
    Name: 'name',
    Category: 'category'
};
/**
 * Describes the size of a company
 * @export
 * @enum {string}
 */
export const CompanySize = {
    SelfEmployed: 'Self-employed',
    _110Employees: '1-10 employees',
    _1150Employees: '11-50 employees',
    _51200Employees: '51-200 employees',
    _201500Employees: '201-500 employees',
    _5011000Employees: '501-1000 employees',
    _10015000Employees: '1001-5000 employees',
    _500110000Employees: '5001-10,000 employees',
    _10001Employees: '10,001+ employees'
};
/**
 * A type of company that an account can represent
 * @export
 * @enum {string}
 */
export const CompanyType = {
    Advertiser: 'advertiser',
    Agency: 'agency',
    Publisher: 'publisher',
    TechnologyProvider: 'technology_provider',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
export const LimitedOrFullFeature = {
    Full: 'full',
    Limited: 'limited'
};
/**
 * The set of events to create for the study.
 * @export
 * @enum {string}
 */
export const MeasurementEventSet = {
    ImpressionsOnly: 'impressions_only',
    ImpressionsAndClicks: 'impressions_and_clicks'
};
export const SendEmailUserFiltersQueryTypeEnum = {
    SingleUser: 'single_user',
    UsersFilter: 'users_filter',
    Everyone: 'everyone'
};
/**
 * The type of shared report
 * @export
 * @enum {string}
 */
export const SharedReportType = {
    AudienceEvaluation: 'audience_evaluation'
};
/**
 *
 * @export
 * @enum {string}
 */
export const StatusSummary = {
    Pending: 'Pending',
    Running: 'Running',
    Succeeded: 'Succeeded',
    Failed: 'Failed'
};
/**
 *
 * @export
 * @enum {string}
 */
export const StudyDeviceTypeCategory = {
    Mobile: 'mobile',
    Desktop: 'desktop',
    Tv: 'tv',
    Bot: 'bot',
    Other: 'other',
    Unknown: 'unknown'
};
/**
 * The status of the data collection of the study, indicating whether stats are available and representative.  * `no_data` means that the study has been created but no data has been received. * `active_ramping_up` means that data has been received, but not enough to provide meaningful stats yet. * `active_fulfilled` means that the study has received a good amount of data, but more data can still be added. * `paused_limited` means that the study was paused because of exceeded limits (typically when `event_cap` is exceeded) * `finished_complete` means that the study has finished and is no longer open to receive data. * `finished_expired` means that the study has finished but not enough data was collected to provide meaningful stats.
 * @export
 * @enum {string}
 */
export const StudyIngestionStatus = {
    NoData: 'no_data',
    ActiveRampingUp: 'active_ramping_up',
    ActiveFulfilled: 'active_fulfilled',
    PausedLimited: 'paused_limited',
    FinishedComplete: 'finished_complete',
    FinishedExpired: 'finished_expired'
};
/**
 * The life cycle stage of the study.
 * @export
 * @enum {string}
 */
export const StudyLifecycleStage = {
    Pending: 'pending',
    Active: 'active',
    Paused: 'paused',
    Finished: 'finished'
};
/**
 * The dimensions that are queryable in the OLAP endpoint.  Notes about the values you can expect in these dimensions:  * The `record_type` is either `private`, `business` or `not_resolved` * Time-based values (`date` and `hour`) are UTC based * The `country` dimension returns 2-letter ISO country codes * The audience dimension values are audience codes such as `a1`, `b2` etc. * If a value is not present, an empty string will be returned
 * @export
 * @enum {string}
 */
export const StudyOlapDimensionKey = {
    RecordType: 'record_type',
    RefererDomain: 'referer_domain',
    RefererPath: 'referer_path',
    DeviceType: 'device_type',
    Country: 'country',
    TimeZone: 'time_zone',
    DateUtc: 'date_utc',
    HourUtc: 'hour_utc',
    DateLocal: 'date_local',
    HourLocal: 'hour_local',
    HomeType: 'home_type',
    Savings: 'savings',
    Lifecycle: 'lifecycle',
    Cars: 'cars',
    Children: 'children',
    Education: 'education',
    NeighbourhoodType: 'neighbourhood_type',
    Income: 'income',
    HomeOwnership: 'home_ownership',
    BuildingAge: 'building_age',
    LivingSpace: 'living_space',
    TechLevel: 'tech_level',
    BusinessSize: 'business_size'
};
/**
 * Currency code for the price
 * @export
 * @enum {string}
 */
export const SubscriptionPriceCurrency = {
    Eur: 'EUR',
    Usd: 'USD',
    Dkk: 'DKK'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SubscriptionPriceInterval = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Annually: 'annually'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SubscriptionProductType = {
    Base: 'base',
    AddOn: 'add-on'
};
/**
 * Determines the role of a user within an account. The permissions of each role are defined to fulfill the following use cases: * `user` is a basic role needed to make use of the platforms primary features. * `admin` is required to perform administrative functions on the account, such as adding members to it. Admin permissions does NOT include removing the account altogether or billing-related actions. * `owner` is required to make changes to account billing, or delete the account.
 * @export
 * @enum {string}
 */
export const UserAccountRole = {
    Owner: 'owner',
    Admin: 'admin',
    User: 'user'
};
/**
 *
 * @export
 * @enum {string}
 */
export const UserIncludeParam = {
    None: 'none',
    Subscriptions: 'subscriptions',
    Account: 'account'
};
/**
 * Defines the role of the user in the Digiseg platform. Most users will not have any platform roles, since this is preserved for account-agnostic operational privileges.
 * @export
 * @enum {string}
 */
export const UserPlatformRole = {
    SuperAdmin: 'super_admin',
    DevOps: 'dev_ops',
    CustomerOps: 'customer_ops'
};
/**
 *
 * @export
 * @enum {string}
 */
export const UserSortOption = {
    CreatedAt: 'created_at',
    CreatedAt2: '-created_at',
    Name: 'name',
    Name2: '-name',
    LoggedInAt: 'logged_in_at',
    LoggedInAt2: '-logged_in_at'
};
/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Adds a user to the referenced account.
         * @summary Add user to account
         * @param {string} accountId
         * @param {AccountUserAddition} accountUserAddition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToAccount: (accountId, accountUserAddition, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('addUserToAccount', 'accountId', accountId);
            // verify required parameter 'accountUserAddition' is not null or undefined
            assertParamExists('addUserToAccount', 'accountUserAddition', accountUserAddition);
            const localVarPath = `/accounts/{account_id}/users`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accountUserAddition, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create account
         * @param {AccountCreation} accountCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: (accountCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountCreation' is not null or undefined
            assertParamExists('createAccount', 'accountCreation', accountCreation);
            const localVarPath = `/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accountCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription: (accountId, accountSubscriptionCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createAccountSubscription', 'accountId', accountId);
            // verify required parameter 'accountSubscriptionCreation' is not null or undefined
            assertParamExists('createAccountSubscription', 'accountSubscriptionCreation', accountSubscriptionCreation);
            const localVarPath = `/accounts/{account_id}/subscriptions`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accountSubscriptionCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountById: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccountById', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes the logo for an account
         * @summary Delete account logo
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountLogo: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccountLogo', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/assets/logo`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById: (accountId, subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccountSubscriptionById', 'accountId', accountId);
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('deleteAccountSubscriptionById', 'subscriptionId', subscriptionId);
            const localVarPath = `/accounts/{account_id}/subscriptions/{subscription_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get account
         * @param {string} accountId
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountById: (accountId, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountById', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the account logo, if the image is hosted on the Digiseg platform. Refer to the account\'s `logo_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get account logo
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLogo: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountLogo', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/assets/logo`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a specific subscription for an account
         * @summary Get account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptionById: (accountId, subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountSubscriptionById', 'accountId', accountId);
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getAccountSubscriptionById', 'subscriptionId', subscriptionId);
            const localVarPath = `/accounts/{account_id}/subscriptions/{subscription_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a summary of subscriptions for an account
         * @summary Get account subscriptions summary
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptions: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountSubscriptions', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/subscriptions`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get information about an account registration. Only accessible to super admins.
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationById: (registrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('getRegistrationById', 'registrationId', registrationId);
            const localVarPath = `/registrations/{registration_id}`
                .replace(`{${"registration_id"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets billing information in Stripe for an account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeBillingInfo: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getStripeBillingInfo', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/subscriptions/billing/stripe`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountMembership: (accountId, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getUserAccountMembership', 'accountId', accountId);
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserAccountMembership', 'userId', userId);
            const localVarPath = `/accounts/{account_id}/users/{user_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List accounts
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {string} [filterNameContains] Optional parameter used to search for accounts where the name contains a substring (case insensitive)
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {AccountSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts: (pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            if (filterNameContains !== undefined) {
                localVarQueryParameter['filter[name][contains]'] = filterNameContains;
            }
            if (filterCreatedAtAfter !== undefined) {
                localVarQueryParameter['filter[created_at][after]'] = (filterCreatedAtAfter instanceof Date) ?
                    filterCreatedAtAfter.toISOString() :
                    filterCreatedAtAfter;
            }
            if (filterCreatedAtBefore !== undefined) {
                localVarQueryParameter['filter[created_at][before]'] = (filterCreatedAtBefore instanceof Date) ?
                    filterCreatedAtBefore.toISOString() :
                    filterCreatedAtBefore;
            }
            if (filterCreatedByAfter !== undefined) {
                localVarQueryParameter['filter[created_by][after]'] = (filterCreatedByAfter instanceof Date) ?
                    filterCreatedByAfter.toISOString() :
                    filterCreatedByAfter;
            }
            if (filterCreatedByBefore !== undefined) {
                localVarQueryParameter['filter[created_by][before]'] = (filterCreatedByBefore instanceof Date) ?
                    filterCreatedByBefore.toISOString() :
                    filterCreatedByBefore;
            }
            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List API keys for account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByAccountId: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listApiKeysByAccountId', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/apikeys`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List users for account
         * @param {string} accountId
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. super_admin
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersByAccountId: (accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listUsersByAccountId', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/users`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterPlatformRoles !== undefined) {
                localVarQueryParameter['filter[platform_roles]'] = filterPlatformRoles;
            }
            if (filterAccountRoles !== undefined) {
                localVarQueryParameter['filter[account_roles]'] = filterAccountRoles;
            }
            if (filterNameContains !== undefined) {
                localVarQueryParameter['filter[name][contains]'] = filterNameContains;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Removes a user from the referenced account.
         * @summary Remove user from account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromAccount: (accountId, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('removeUserFromAccount', 'accountId', accountId);
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserFromAccount', 'userId', userId);
            const localVarPath = `/accounts/{account_id}/users/{user_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync account information with Stripe
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncAccount: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('stripeSyncAccount', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/sync/stripe`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Start the account registration process, which starts with verifying the authenticity of the user\'s email address. Upon verification, an account and user will be created.
         * @summary Submit account registration flow
         * @param {RegistrationRequest} registrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitRegistration: (registrationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registrationRequest' is not null or undefined
            assertParamExists('submitRegistration', 'registrationRequest', registrationRequest);
            const localVarPath = `/auth/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registrationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update account
         * @param {string} accountId
         * @param {AccountMutation} accountMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountById: (accountId, accountMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateAccountById', 'accountId', accountId);
            // verify required parameter 'accountMutation' is not null or undefined
            assertParamExists('updateAccountById', 'accountMutation', accountMutation);
            const localVarPath = `/accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accountMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {UserAccountMembershipUpdate} userAccountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountMembership: (accountId, userId, userAccountMembershipUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateUserAccountMembership', 'accountId', accountId);
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserAccountMembership', 'userId', userId);
            // verify required parameter 'userAccountMembershipUpdate' is not null or undefined
            assertParamExists('updateUserAccountMembership', 'userAccountMembershipUpdate', userAccountMembershipUpdate);
            const localVarPath = `/accounts/{account_id}/users/{user_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userAccountMembershipUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upload a logo for an account
         * @summary Upload account logo
         * @param {string} accountId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAccountLogo: (accountId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('uploadAccountLogo', 'accountId', accountId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('uploadAccountLogo', 'body', body);
            const localVarPath = `/accounts/{account_id}/assets/logo`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'image/gif';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify account registration
         * @param {string} registrationId
         * @param {string} verificationCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration: (registrationId, verificationCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('verifyRegistration', 'registrationId', registrationId);
            // verify required parameter 'verificationCode' is not null or undefined
            assertParamExists('verifyRegistration', 'verificationCode', verificationCode);
            const localVarPath = `/auth/verify_registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (registrationId !== undefined) {
                localVarQueryParameter['registration_id'] = registrationId;
            }
            if (verificationCode !== undefined) {
                localVarQueryParameter['verification_code'] = verificationCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration);
    return {
        /**
         * Adds a user to the referenced account.
         * @summary Add user to account
         * @param {string} accountId
         * @param {AccountUserAddition} accountUserAddition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToAccount(accountId, accountUserAddition, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addUserToAccount(accountId, accountUserAddition, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.addUserToAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create account
         * @param {AccountCreation} accountCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(accountCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccount(accountCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.createAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription(accountId, accountSubscriptionCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccountSubscription(accountId, accountSubscriptionCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.createAccountSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountById(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccountById(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.deleteAccountById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes the logo for an account
         * @summary Delete account logo
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountLogo(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccountLogo(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.deleteAccountLogo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById(accountId, subscriptionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccountSubscriptionById(accountId, subscriptionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.deleteAccountSubscriptionById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get account
         * @param {string} accountId
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountById(accountId, include, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountById(accountId, include, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.getAccountById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets the account logo, if the image is hosted on the Digiseg platform. Refer to the account\'s `logo_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get account logo
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLogo(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountLogo(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.getAccountLogo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets a specific subscription for an account
         * @summary Get account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptionById(accountId, subscriptionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountSubscriptionById(accountId, subscriptionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.getAccountSubscriptionById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a summary of subscriptions for an account
         * @summary Get account subscriptions summary
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptions(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountSubscriptions(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.getAccountSubscriptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get information about an account registration. Only accessible to super admins.
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationById(registrationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRegistrationById(registrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.getRegistrationById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Gets billing information in Stripe for an account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeBillingInfo(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStripeBillingInfo(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.getStripeBillingInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountMembership(accountId, userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserAccountMembership(accountId, userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.getUserAccountMembership']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List accounts
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {string} [filterNameContains] Optional parameter used to search for accounts where the name contains a substring (case insensitive)
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {AccountSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.listAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List API keys for account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByAccountId(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listApiKeysByAccountId(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.listApiKeysByAccountId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List users for account
         * @param {string} accountId
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. super_admin
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.listUsersByAccountId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Removes a user from the referenced account.
         * @summary Remove user from account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromAccount(accountId, userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeUserFromAccount(accountId, userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.removeUserFromAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sync account information with Stripe
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncAccount(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.stripeSyncAccount(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.stripeSyncAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Start the account registration process, which starts with verifying the authenticity of the user\'s email address. Upon verification, an account and user will be created.
         * @summary Submit account registration flow
         * @param {RegistrationRequest} registrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitRegistration(registrationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitRegistration(registrationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.submitRegistration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update account
         * @param {string} accountId
         * @param {AccountMutation} accountMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountById(accountId, accountMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAccountById(accountId, accountMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.updateAccountById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {UserAccountMembershipUpdate} userAccountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.updateUserAccountMembership']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Upload a logo for an account
         * @summary Upload account logo
         * @param {string} accountId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAccountLogo(accountId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadAccountLogo(accountId, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.uploadAccountLogo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Verify account registration
         * @param {string} registrationId
         * @param {string} verificationCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration(registrationId, verificationCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyRegistration(registrationId, verificationCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountsApi.verifyRegistration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountsApiFp(configuration);
    return {
        /**
         * Adds a user to the referenced account.
         * @summary Add user to account
         * @param {string} accountId
         * @param {AccountUserAddition} accountUserAddition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToAccount(accountId, accountUserAddition, options) {
            return localVarFp.addUserToAccount(accountId, accountUserAddition, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create account
         * @param {AccountCreation} accountCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(accountCreation, options) {
            return localVarFp.createAccount(accountCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription(accountId, accountSubscriptionCreation, options) {
            return localVarFp.createAccountSubscription(accountId, accountSubscriptionCreation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountById(accountId, options) {
            return localVarFp.deleteAccountById(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the logo for an account
         * @summary Delete account logo
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountLogo(accountId, options) {
            return localVarFp.deleteAccountLogo(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById(accountId, subscriptionId, options) {
            return localVarFp.deleteAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get account
         * @param {string} accountId
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountById(accountId, include, options) {
            return localVarFp.getAccountById(accountId, include, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the account logo, if the image is hosted on the Digiseg platform. Refer to the account\'s `logo_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get account logo
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLogo(accountId, options) {
            return localVarFp.getAccountLogo(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a specific subscription for an account
         * @summary Get account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptionById(accountId, subscriptionId, options) {
            return localVarFp.getAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a summary of subscriptions for an account
         * @summary Get account subscriptions summary
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptions(accountId, options) {
            return localVarFp.getAccountSubscriptions(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information about an account registration. Only accessible to super admins.
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationById(registrationId, options) {
            return localVarFp.getRegistrationById(registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets billing information in Stripe for an account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeBillingInfo(accountId, options) {
            return localVarFp.getStripeBillingInfo(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountMembership(accountId, userId, options) {
            return localVarFp.getUserAccountMembership(accountId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List accounts
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {string} [filterNameContains] Optional parameter used to search for accounts where the name contains a substring (case insensitive)
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {AccountSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options) {
            return localVarFp.listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List API keys for account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByAccountId(accountId, options) {
            return localVarFp.listApiKeysByAccountId(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List users for account
         * @param {string} accountId
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. super_admin
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options) {
            return localVarFp.listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a user from the referenced account.
         * @summary Remove user from account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromAccount(accountId, userId, options) {
            return localVarFp.removeUserFromAccount(accountId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync account information with Stripe
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncAccount(accountId, options) {
            return localVarFp.stripeSyncAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Start the account registration process, which starts with verifying the authenticity of the user\'s email address. Upon verification, an account and user will be created.
         * @summary Submit account registration flow
         * @param {RegistrationRequest} registrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitRegistration(registrationRequest, options) {
            return localVarFp.submitRegistration(registrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update account
         * @param {string} accountId
         * @param {AccountMutation} accountMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountById(accountId, accountMutation, options) {
            return localVarFp.updateAccountById(accountId, accountMutation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {UserAccountMembershipUpdate} userAccountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options) {
            return localVarFp.updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a logo for an account
         * @summary Upload account logo
         * @param {string} accountId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAccountLogo(accountId, body, options) {
            return localVarFp.uploadAccountLogo(accountId, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify account registration
         * @param {string} registrationId
         * @param {string} verificationCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration(registrationId, verificationCode, options) {
            return localVarFp.verifyRegistration(registrationId, verificationCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     * Adds a user to the referenced account.
     * @summary Add user to account
     * @param {string} accountId
     * @param {AccountUserAddition} accountUserAddition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    addUserToAccount(accountId, accountUserAddition, options) {
        return AccountsApiFp(this.configuration).addUserToAccount(accountId, accountUserAddition, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create account
     * @param {AccountCreation} accountCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    createAccount(accountCreation, options) {
        return AccountsApiFp(this.configuration).createAccount(accountCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a subscription on an account. Only permitted for super-admins.
     * @summary Create account subscription
     * @param {string} accountId
     * @param {AccountSubscriptionCreation} accountSubscriptionCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    createAccountSubscription(accountId, accountSubscriptionCreation, options) {
        return AccountsApiFp(this.configuration).createAccountSubscription(accountId, accountSubscriptionCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete account
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    deleteAccountById(accountId, options) {
        return AccountsApiFp(this.configuration).deleteAccountById(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the logo for an account
     * @summary Delete account logo
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    deleteAccountLogo(accountId, options) {
        return AccountsApiFp(this.configuration).deleteAccountLogo(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a subscription on an account. Only permitted for super-admins.
     * @summary Delete account subscription
     * @param {string} accountId
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    deleteAccountSubscriptionById(accountId, subscriptionId, options) {
        return AccountsApiFp(this.configuration).deleteAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get account
     * @param {string} accountId
     * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccountById(accountId, include, options) {
        return AccountsApiFp(this.configuration).getAccountById(accountId, include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the account logo, if the image is hosted on the Digiseg platform. Refer to the account\'s `logo_url` to get a non-authenticated and shareable URL for the logo.
     * @summary Get account logo
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccountLogo(accountId, options) {
        return AccountsApiFp(this.configuration).getAccountLogo(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a specific subscription for an account
     * @summary Get account subscription
     * @param {string} accountId
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccountSubscriptionById(accountId, subscriptionId, options) {
        return AccountsApiFp(this.configuration).getAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a summary of subscriptions for an account
     * @summary Get account subscriptions summary
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccountSubscriptions(accountId, options) {
        return AccountsApiFp(this.configuration).getAccountSubscriptions(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get information about an account registration. Only accessible to super admins.
     * @param {string} registrationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getRegistrationById(registrationId, options) {
        return AccountsApiFp(this.configuration).getRegistrationById(registrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets billing information in Stripe for an account
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getStripeBillingInfo(accountId, options) {
        return AccountsApiFp(this.configuration).getStripeBillingInfo(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a user\'s membership with an account
     * @param {string} accountId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getUserAccountMembership(accountId, userId, options) {
        return AccountsApiFp(this.configuration).getUserAccountMembership(accountId, userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List accounts
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {string} [filterNameContains] Optional parameter used to search for accounts where the name contains a substring (case insensitive)
     * @param {string} [filterCreatedAtAfter] Optional parameter used to search for accounts created after the specified date-time
     * @param {string} [filterCreatedAtBefore] Optional parameter used to search for accounts created after the specified date-time
     * @param {string} [filterCreatedByAfter] Optional parameter used to search for accounts created after the specified date-time
     * @param {string} [filterCreatedByBefore] Optional parameter used to search for accounts created after the specified date-time
     * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
     * @param {AccountSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options) {
        return AccountsApiFp(this.configuration).listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List API keys for account
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    listApiKeysByAccountId(accountId, options) {
        return AccountsApiFp(this.configuration).listApiKeysByAccountId(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List users for account
     * @param {string} accountId
     * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. super_admin
     * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
     * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
     * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options) {
        return AccountsApiFp(this.configuration).listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removes a user from the referenced account.
     * @summary Remove user from account
     * @param {string} accountId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    removeUserFromAccount(accountId, userId, options) {
        return AccountsApiFp(this.configuration).removeUserFromAccount(accountId, userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync account information with Stripe
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    stripeSyncAccount(accountId, options) {
        return AccountsApiFp(this.configuration).stripeSyncAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Start the account registration process, which starts with verifying the authenticity of the user\'s email address. Upon verification, an account and user will be created.
     * @summary Submit account registration flow
     * @param {RegistrationRequest} registrationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    submitRegistration(registrationRequest, options) {
        return AccountsApiFp(this.configuration).submitRegistration(registrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update account
     * @param {string} accountId
     * @param {AccountMutation} accountMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    updateAccountById(accountId, accountMutation, options) {
        return AccountsApiFp(this.configuration).updateAccountById(accountId, accountMutation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a user\'s membership with an account
     * @param {string} accountId
     * @param {string} userId
     * @param {UserAccountMembershipUpdate} userAccountMembershipUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options) {
        return AccountsApiFp(this.configuration).updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload a logo for an account
     * @summary Upload account logo
     * @param {string} accountId
     * @param {File} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    uploadAccountLogo(accountId, body, options) {
        return AccountsApiFp(this.configuration).uploadAccountLogo(accountId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify account registration
     * @param {string} registrationId
     * @param {string} verificationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    verifyRegistration(registrationId, verificationCode, options) {
        return AccountsApiFp(this.configuration).verifyRegistration(registrationId, verificationCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AudiencesApi - axios parameter creator
 * @export
 */
export const AudiencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This endpoint provides a set of example IP addresses that can be used to explore and demonstrate the Audience API capabilities.
         * @summary Get example IP addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExampleIps: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/audiences/examples`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get audiences of the API client
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {string} [type] Optional parameter to set to &#x60;jsonp&#x60; if a JSONP response format is needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfClient: (include, type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/audiences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get audiences for multiple IP addresses
         * @param {ResolveAudiencesOfMultipleRequest} resolveAudiencesOfMultipleRequest
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfMultiple: (resolveAudiencesOfMultipleRequest, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resolveAudiencesOfMultipleRequest' is not null or undefined
            assertParamExists('resolveAudiencesOfMultiple', 'resolveAudiencesOfMultipleRequest', resolveAudiencesOfMultipleRequest);
            const localVarPath = `/audiences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(resolveAudiencesOfMultipleRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get audiences for a given IP address
         * @param {string} userIp The IP address to look up.
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfSingle: (userIp, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userIp' is not null or undefined
            assertParamExists('resolveAudiencesOfSingle', 'userIp', userIp);
            const localVarPath = `/audiences/{user_ip}`
                .replace(`{${"user_ip"}}`, encodeURIComponent(String(userIp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AudiencesApi - functional programming interface
 * @export
 */
export const AudiencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AudiencesApiAxiosParamCreator(configuration);
    return {
        /**
         * This endpoint provides a set of example IP addresses that can be used to explore and demonstrate the Audience API capabilities.
         * @summary Get example IP addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExampleIps(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExampleIps(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getExampleIps']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get audiences of the API client
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {string} [type] Optional parameter to set to &#x60;jsonp&#x60; if a JSONP response format is needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfClient(include, type, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveAudiencesOfClient(include, type, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.resolveAudiencesOfClient']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get audiences for multiple IP addresses
         * @param {ResolveAudiencesOfMultipleRequest} resolveAudiencesOfMultipleRequest
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfMultiple(resolveAudiencesOfMultipleRequest, include, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveAudiencesOfMultiple(resolveAudiencesOfMultipleRequest, include, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.resolveAudiencesOfMultiple']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get audiences for a given IP address
         * @param {string} userIp The IP address to look up.
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfSingle(userIp, include, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveAudiencesOfSingle(userIp, include, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.resolveAudiencesOfSingle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AudiencesApi - factory interface
 * @export
 */
export const AudiencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AudiencesApiFp(configuration);
    return {
        /**
         * This endpoint provides a set of example IP addresses that can be used to explore and demonstrate the Audience API capabilities.
         * @summary Get example IP addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExampleIps(options) {
            return localVarFp.getExampleIps(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get audiences of the API client
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {string} [type] Optional parameter to set to &#x60;jsonp&#x60; if a JSONP response format is needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfClient(include, type, options) {
            return localVarFp.resolveAudiencesOfClient(include, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get audiences for multiple IP addresses
         * @param {ResolveAudiencesOfMultipleRequest} resolveAudiencesOfMultipleRequest
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfMultiple(resolveAudiencesOfMultipleRequest, include, options) {
            return localVarFp.resolveAudiencesOfMultiple(resolveAudiencesOfMultipleRequest, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get audiences for a given IP address
         * @param {string} userIp The IP address to look up.
         * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAudiencesOfSingle(userIp, include, options) {
            return localVarFp.resolveAudiencesOfSingle(userIp, include, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AudiencesApi - object-oriented interface
 * @export
 * @class AudiencesApi
 * @extends {BaseAPI}
 */
export class AudiencesApi extends BaseAPI {
    /**
     * This endpoint provides a set of example IP addresses that can be used to explore and demonstrate the Audience API capabilities.
     * @summary Get example IP addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getExampleIps(options) {
        return AudiencesApiFp(this.configuration).getExampleIps(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get audiences of the API client
     * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
     * @param {string} [type] Optional parameter to set to &#x60;jsonp&#x60; if a JSONP response format is needed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    resolveAudiencesOfClient(include, type, options) {
        return AudiencesApiFp(this.configuration).resolveAudiencesOfClient(include, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get audiences for multiple IP addresses
     * @param {ResolveAudiencesOfMultipleRequest} resolveAudiencesOfMultipleRequest
     * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    resolveAudiencesOfMultiple(resolveAudiencesOfMultipleRequest, include, options) {
        return AudiencesApiFp(this.configuration).resolveAudiencesOfMultiple(resolveAudiencesOfMultipleRequest, include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get audiences for a given IP address
     * @param {string} userIp The IP address to look up.
     * @param {Array<AudiencesIncludeParam>} [include] Optional parameter used to specify which audience information to be returned. The value is comprised of comma-separated values, each indicating a set of audiences:    * &#x60;core&#x60; represents the core audiences that are directly linked to household characteristics   * &#x60;composite&#x60; represents the composite audiences, used to model likely behaviours or buying     needs associated with the household characteristics.   * &#x60;name&#x60; and &#x60;category&#x60; refer to the fields of the same names in the returned Audience     objects. There is a slight performance gain in leaving these out when they are not needed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    resolveAudiencesOfSingle(userIp, include, options) {
        return AudiencesApiFp(this.configuration).resolveAudiencesOfSingle(userIp, include, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Internal endpoint used to authenticate an incoming request. The endpoint will validate the provided Access Token or API key.
         * @summary Authenticate incoming request
         * @param {string} xOriginalUri
         * @param {string} xOriginalMethod
         * @param {string} [authorization]
         * @param {string} [xAPIKEY]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateIncomingRequest: (xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xOriginalUri' is not null or undefined
            assertParamExists('authenticateIncomingRequest', 'xOriginalUri', xOriginalUri);
            // verify required parameter 'xOriginalMethod' is not null or undefined
            assertParamExists('authenticateIncomingRequest', 'xOriginalMethod', xOriginalMethod);
            const localVarPath = `/auth/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (xOriginalUri != null) {
                localVarHeaderParameter['X-Original-Uri'] = String(xOriginalUri);
            }
            if (xOriginalMethod != null) {
                localVarHeaderParameter['X-Original-Method'] = String(xOriginalMethod);
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Authenticate and create access token
         * @param {AuthTokenRequest} authTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken: (authTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'authTokenRequest' is not null or undefined
            assertParamExists('createAccessToken', 'authTokenRequest', authTokenRequest);
            const localVarPath = `/auth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(authTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create API key for the given user. When an API key is created, the `token` value will be exposed in the response. This token can be passed as the `X-API-KEY` header value for future requests. It is not obtainable in other API requests (ie. the client must decide how to keep the API key token in e.g. a vault or similar).
         * @summary Create API key
         * @param {string} userId
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey: (userId, apiKeyCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createApiKey', 'userId', userId);
            // verify required parameter 'apiKeyCreation' is not null or undefined
            assertParamExists('createApiKey', 'apiKeyCreation', apiKeyCreation);
            const localVarPath = `/users/{user_id}/apikeys`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create an access token for one or more shared resources
         * @param {ResourceSharingTokenRequest} resourceSharingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceSharingToken: (resourceSharingTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceSharingTokenRequest' is not null or undefined
            assertParamExists('createResourceSharingToken', 'resourceSharingTokenRequest', resourceSharingTokenRequest);
            const localVarPath = `/auth/resource_share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(resourceSharingTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyById: (userId, keyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteApiKeyById', 'userId', userId);
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('deleteApiKeyById', 'keyId', keyId);
            const localVarPath = `/users/{user_id}/apikeys/{key_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"key_id"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyById: (userId, keyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getApiKeyById', 'userId', userId);
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('getApiKeyById', 'keyId', keyId);
            const localVarPath = `/users/{user_id}/apikeys/{key_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"key_id"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List API keys for account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByAccountId: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listApiKeysByAccountId', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/apikeys`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List API keys for user
         * @param {string} userId
         * @param {string} [filterAccountId] Filter by specific account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByUserId: (userId, filterAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listApiKeysByUserId', 'userId', userId);
            const localVarPath = `/users/{user_id}/apikeys`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Start the authentication process using passwordless auth. This process starts with sending a one-time password (OTP) to the user with the provided email address.
         * @summary Submit passwordless auth flow
         * @param {PasswordlessAuthRequest} passwordlessAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPasswordlessAuth: (passwordlessAuthRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'passwordlessAuthRequest' is not null or undefined
            assertParamExists('submitPasswordlessAuth', 'passwordlessAuthRequest', passwordlessAuthRequest);
            const localVarPath = `/auth/passwordless`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(passwordlessAuthRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update API key
         * @param {string} userId
         * @param {string} keyId
         * @param {ApiKeyMutation} apiKeyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyById: (userId, keyId, apiKeyMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateApiKeyById', 'userId', userId);
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('updateApiKeyById', 'keyId', keyId);
            // verify required parameter 'apiKeyMutation' is not null or undefined
            assertParamExists('updateApiKeyById', 'apiKeyMutation', apiKeyMutation);
            const localVarPath = `/users/{user_id}/apikeys/{key_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"key_id"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
    return {
        /**
         * Internal endpoint used to authenticate an incoming request. The endpoint will validate the provided Access Token or API key.
         * @summary Authenticate incoming request
         * @param {string} xOriginalUri
         * @param {string} xOriginalMethod
         * @param {string} [authorization]
         * @param {string} [xAPIKEY]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.authenticateIncomingRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Authenticate and create access token
         * @param {AuthTokenRequest} authTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken(authTokenRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccessToken(authTokenRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.createAccessToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create API key for the given user. When an API key is created, the `token` value will be exposed in the response. This token can be passed as the `X-API-KEY` header value for future requests. It is not obtainable in other API requests (ie. the client must decide how to keep the API key token in e.g. a vault or similar).
         * @summary Create API key
         * @param {string} userId
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey(userId, apiKeyCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createApiKey(userId, apiKeyCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.createApiKey']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create an access token for one or more shared resources
         * @param {ResourceSharingTokenRequest} resourceSharingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceSharingToken(resourceSharingTokenRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createResourceSharingToken(resourceSharingTokenRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.createResourceSharingToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyById(userId, keyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteApiKeyById(userId, keyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.deleteApiKeyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyById(userId, keyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApiKeyById(userId, keyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.getApiKeyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List API keys for account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByAccountId(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listApiKeysByAccountId(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.listApiKeysByAccountId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List API keys for user
         * @param {string} userId
         * @param {string} [filterAccountId] Filter by specific account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByUserId(userId, filterAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listApiKeysByUserId(userId, filterAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.listApiKeysByUserId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Start the authentication process using passwordless auth. This process starts with sending a one-time password (OTP) to the user with the provided email address.
         * @summary Submit passwordless auth flow
         * @param {PasswordlessAuthRequest} passwordlessAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPasswordlessAuth(passwordlessAuthRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitPasswordlessAuth(passwordlessAuthRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.submitPasswordlessAuth']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update API key
         * @param {string} userId
         * @param {string} keyId
         * @param {ApiKeyMutation} apiKeyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyById(userId, keyId, apiKeyMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApiKeyById(userId, keyId, apiKeyMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthApi.updateApiKeyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthApiFp(configuration);
    return {
        /**
         * Internal endpoint used to authenticate an incoming request. The endpoint will validate the provided Access Token or API key.
         * @summary Authenticate incoming request
         * @param {string} xOriginalUri
         * @param {string} xOriginalMethod
         * @param {string} [authorization]
         * @param {string} [xAPIKEY]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options) {
            return localVarFp.authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Authenticate and create access token
         * @param {AuthTokenRequest} authTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken(authTokenRequest, options) {
            return localVarFp.createAccessToken(authTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create API key for the given user. When an API key is created, the `token` value will be exposed in the response. This token can be passed as the `X-API-KEY` header value for future requests. It is not obtainable in other API requests (ie. the client must decide how to keep the API key token in e.g. a vault or similar).
         * @summary Create API key
         * @param {string} userId
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey(userId, apiKeyCreation, options) {
            return localVarFp.createApiKey(userId, apiKeyCreation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an access token for one or more shared resources
         * @param {ResourceSharingTokenRequest} resourceSharingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceSharingToken(resourceSharingTokenRequest, options) {
            return localVarFp.createResourceSharingToken(resourceSharingTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyById(userId, keyId, options) {
            return localVarFp.deleteApiKeyById(userId, keyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyById(userId, keyId, options) {
            return localVarFp.getApiKeyById(userId, keyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List API keys for account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByAccountId(accountId, options) {
            return localVarFp.listApiKeysByAccountId(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List API keys for user
         * @param {string} userId
         * @param {string} [filterAccountId] Filter by specific account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByUserId(userId, filterAccountId, options) {
            return localVarFp.listApiKeysByUserId(userId, filterAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Start the authentication process using passwordless auth. This process starts with sending a one-time password (OTP) to the user with the provided email address.
         * @summary Submit passwordless auth flow
         * @param {PasswordlessAuthRequest} passwordlessAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPasswordlessAuth(passwordlessAuthRequest, options) {
            return localVarFp.submitPasswordlessAuth(passwordlessAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update API key
         * @param {string} userId
         * @param {string} keyId
         * @param {ApiKeyMutation} apiKeyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyById(userId, keyId, apiKeyMutation, options) {
            return localVarFp.updateApiKeyById(userId, keyId, apiKeyMutation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Internal endpoint used to authenticate an incoming request. The endpoint will validate the provided Access Token or API key.
     * @summary Authenticate incoming request
     * @param {string} xOriginalUri
     * @param {string} xOriginalMethod
     * @param {string} [authorization]
     * @param {string} [xAPIKEY]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options) {
        return AuthApiFp(this.configuration).authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Authenticate and create access token
     * @param {AuthTokenRequest} authTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createAccessToken(authTokenRequest, options) {
        return AuthApiFp(this.configuration).createAccessToken(authTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create API key for the given user. When an API key is created, the `token` value will be exposed in the response. This token can be passed as the `X-API-KEY` header value for future requests. It is not obtainable in other API requests (ie. the client must decide how to keep the API key token in e.g. a vault or similar).
     * @summary Create API key
     * @param {string} userId
     * @param {ApiKeyCreation} apiKeyCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createApiKey(userId, apiKeyCreation, options) {
        return AuthApiFp(this.configuration).createApiKey(userId, apiKeyCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an access token for one or more shared resources
     * @param {ResourceSharingTokenRequest} resourceSharingTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createResourceSharingToken(resourceSharingTokenRequest, options) {
        return AuthApiFp(this.configuration).createResourceSharingToken(resourceSharingTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete API key
     * @param {string} userId
     * @param {string} keyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    deleteApiKeyById(userId, keyId, options) {
        return AuthApiFp(this.configuration).deleteApiKeyById(userId, keyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get API key
     * @param {string} userId
     * @param {string} keyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    getApiKeyById(userId, keyId, options) {
        return AuthApiFp(this.configuration).getApiKeyById(userId, keyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List API keys for account
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    listApiKeysByAccountId(accountId, options) {
        return AuthApiFp(this.configuration).listApiKeysByAccountId(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List API keys for user
     * @param {string} userId
     * @param {string} [filterAccountId] Filter by specific account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    listApiKeysByUserId(userId, filterAccountId, options) {
        return AuthApiFp(this.configuration).listApiKeysByUserId(userId, filterAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Start the authentication process using passwordless auth. This process starts with sending a one-time password (OTP) to the user with the provided email address.
     * @summary Submit passwordless auth flow
     * @param {PasswordlessAuthRequest} passwordlessAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    submitPasswordlessAuth(passwordlessAuthRequest, options) {
        return AuthApiFp(this.configuration).submitPasswordlessAuth(passwordlessAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update API key
     * @param {string} userId
     * @param {string} keyId
     * @param {ApiKeyMutation} apiKeyMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    updateApiKeyById(userId, keyId, apiKeyMutation, options) {
        return AuthApiFp(this.configuration).updateApiKeyById(userId, keyId, apiKeyMutation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new custom job
         * @param {CreateCustomJobRequest} [createCustomJobRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomJob: (createCustomJobRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pipelines/jobs/custom`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomJobRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new default job
         * @param {CreateDefaultJobRequest} [createDefaultJobRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultJob: (createDefaultJobRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pipelines/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createDefaultJobRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete job by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJob', 'id', id);
            const localVarPath = `/pipelines/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobById', 'id', id);
            const localVarPath = `/pipelines/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get status of job by Job Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatusByJobId: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobStatusByJobId', 'id', id);
            const localVarPath = `/pipelines/jobs/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all jobs
         * @param {string} [filterSerialNumber] Filter based on the jobs serial number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs: (filterSerialNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pipelines/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterSerialNumber !== undefined) {
                localVarQueryParameter['filter[serial_number]'] = filterSerialNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update job by Id
         * @param {string} id
         * @param {JobMutation} [jobMutation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobById: (id, jobMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateJobById', 'id', id);
            const localVarPath = `/pipelines/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(jobMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function (configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new custom job
         * @param {CreateCustomJobRequest} [createCustomJobRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomJob(createCustomJobRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCustomJob(createCustomJobRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.createCustomJob']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create a new default job
         * @param {CreateDefaultJobRequest} [createDefaultJobRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultJob(createDefaultJobRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDefaultJob(createDefaultJobRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.createDefaultJob']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete job by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteJob(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.deleteJob']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getJobById(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.getJobById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get status of job by Job Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatusByJobId(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getJobStatusByJobId(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.getJobStatusByJobId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all jobs
         * @param {string} [filterSerialNumber] Filter based on the jobs serial number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs(filterSerialNumber, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getJobs(filterSerialNumber, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.getJobs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update job by Id
         * @param {string} id
         * @param {JobMutation} [jobMutation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobById(id, jobMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateJobById(id, jobMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.updateJobById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = JobsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new custom job
         * @param {CreateCustomJobRequest} [createCustomJobRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomJob(createCustomJobRequest, options) {
            return localVarFp.createCustomJob(createCustomJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new default job
         * @param {CreateDefaultJobRequest} [createDefaultJobRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultJob(createDefaultJobRequest, options) {
            return localVarFp.createDefaultJob(createDefaultJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete job by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob(id, options) {
            return localVarFp.deleteJob(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById(id, options) {
            return localVarFp.getJobById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get status of job by Job Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatusByJobId(id, options) {
            return localVarFp.getJobStatusByJobId(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all jobs
         * @param {string} [filterSerialNumber] Filter based on the jobs serial number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs(filterSerialNumber, options) {
            return localVarFp.getJobs(filterSerialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update job by Id
         * @param {string} id
         * @param {JobMutation} [jobMutation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobById(id, jobMutation, options) {
            return localVarFp.updateJobById(id, jobMutation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     *
     * @summary Create a new custom job
     * @param {CreateCustomJobRequest} [createCustomJobRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    createCustomJob(createCustomJobRequest, options) {
        return JobsApiFp(this.configuration).createCustomJob(createCustomJobRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new default job
     * @param {CreateDefaultJobRequest} [createDefaultJobRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    createDefaultJob(createDefaultJobRequest, options) {
        return JobsApiFp(this.configuration).createDefaultJob(createDefaultJobRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete job by Id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    deleteJob(id, options) {
        return JobsApiFp(this.configuration).deleteJob(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job by Id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    getJobById(id, options) {
        return JobsApiFp(this.configuration).getJobById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get status of job by Job Id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    getJobStatusByJobId(id, options) {
        return JobsApiFp(this.configuration).getJobStatusByJobId(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all jobs
     * @param {string} [filterSerialNumber] Filter based on the jobs serial number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    getJobs(filterSerialNumber, options) {
        return JobsApiFp(this.configuration).getJobs(filterSerialNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update job by Id
     * @param {string} id
     * @param {JobMutation} [jobMutation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    updateJobById(id, jobMutation, options) {
        return JobsApiFp(this.configuration).updateJobById(id, jobMutation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MeasurementClientsApi - axios parameter creator
 * @export
 */
export const MeasurementClientsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a measurement client in the account of the user
         * @summary Create measurement client
         * @param {MeasurementClientMutation} measurementClientMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeasurementClient: (measurementClientMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'measurementClientMutation' is not null or undefined
            assertParamExists('createMeasurementClient', 'measurementClientMutation', measurementClientMutation);
            const localVarPath = `/measurement/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(measurementClientMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes the logo for a client
         * @summary Delete measurement client logo
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientLogo: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteClientLogo', 'clientId', clientId);
            const localVarPath = `/measurement/clients/{client_id}/assets/logo`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a measurement client
         * @summary Delete measurement client
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementClientById: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteMeasurementClientById', 'clientId', clientId);
            const localVarPath = `/measurement/clients/{client_id}`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the client logo, if the image is hosted on the Digiseg platform. Refer to the clients\'s `logo_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get measurement client logo
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientLogo: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getClientLogo', 'clientId', clientId);
            const localVarPath = `/measurement/clients/{client_id}/assets/logo`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get information for a specific measurement client
         * @summary Get measurement client
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementClientById: (clientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getMeasurementClientById', 'clientId', clientId);
            const localVarPath = `/measurement/clients/{client_id}`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List measurement clients that the user has access to
         * @summary List measurement clients
         * @param {string} [filterAccountId] Optional parameter used to query measurement clients by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {string} [filterNameContains] Optional parameter used to search for clients where the name contains a substring (case insensitive)
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeasurementClients: (filterAccountId, filterNameContains, pageSize, pageAfter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/measurement/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            if (filterNameContains !== undefined) {
                localVarQueryParameter['filter[name][contains]'] = filterNameContains;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates properties of a measurement client
         * @summary Update measurement client
         * @param {string} clientId
         * @param {MeasurementClientMutation} measurementClientMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeasurementClientById: (clientId, measurementClientMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateMeasurementClientById', 'clientId', clientId);
            // verify required parameter 'measurementClientMutation' is not null or undefined
            assertParamExists('updateMeasurementClientById', 'measurementClientMutation', measurementClientMutation);
            const localVarPath = `/measurement/clients/{client_id}`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(measurementClientMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upload a logo for a client
         * @summary Upload measurement client logo
         * @param {string} clientId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientLogo: (clientId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('uploadClientLogo', 'clientId', clientId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('uploadClientLogo', 'body', body);
            const localVarPath = `/measurement/clients/{client_id}/assets/logo`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'image/gif';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MeasurementClientsApi - functional programming interface
 * @export
 */
export const MeasurementClientsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MeasurementClientsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a measurement client in the account of the user
         * @summary Create measurement client
         * @param {MeasurementClientMutation} measurementClientMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeasurementClient(measurementClientMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMeasurementClient(measurementClientMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementClientsApi.createMeasurementClient']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes the logo for a client
         * @summary Delete measurement client logo
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientLogo(clientId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteClientLogo(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementClientsApi.deleteClientLogo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes a measurement client
         * @summary Delete measurement client
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementClientById(clientId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMeasurementClientById(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementClientsApi.deleteMeasurementClientById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets the client logo, if the image is hosted on the Digiseg platform. Refer to the clients\'s `logo_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get measurement client logo
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientLogo(clientId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClientLogo(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementClientsApi.getClientLogo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get information for a specific measurement client
         * @summary Get measurement client
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementClientById(clientId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMeasurementClientById(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementClientsApi.getMeasurementClientById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List measurement clients that the user has access to
         * @summary List measurement clients
         * @param {string} [filterAccountId] Optional parameter used to query measurement clients by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {string} [filterNameContains] Optional parameter used to search for clients where the name contains a substring (case insensitive)
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeasurementClients(filterAccountId, filterNameContains, pageSize, pageAfter, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMeasurementClients(filterAccountId, filterNameContains, pageSize, pageAfter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementClientsApi.listMeasurementClients']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Updates properties of a measurement client
         * @summary Update measurement client
         * @param {string} clientId
         * @param {MeasurementClientMutation} measurementClientMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeasurementClientById(clientId, measurementClientMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMeasurementClientById(clientId, measurementClientMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementClientsApi.updateMeasurementClientById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Upload a logo for a client
         * @summary Upload measurement client logo
         * @param {string} clientId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientLogo(clientId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadClientLogo(clientId, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementClientsApi.uploadClientLogo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * MeasurementClientsApi - factory interface
 * @export
 */
export const MeasurementClientsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MeasurementClientsApiFp(configuration);
    return {
        /**
         * Create a measurement client in the account of the user
         * @summary Create measurement client
         * @param {MeasurementClientMutation} measurementClientMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeasurementClient(measurementClientMutation, options) {
            return localVarFp.createMeasurementClient(measurementClientMutation, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the logo for a client
         * @summary Delete measurement client logo
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientLogo(clientId, options) {
            return localVarFp.deleteClientLogo(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a measurement client
         * @summary Delete measurement client
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementClientById(clientId, options) {
            return localVarFp.deleteMeasurementClientById(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the client logo, if the image is hosted on the Digiseg platform. Refer to the clients\'s `logo_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get measurement client logo
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientLogo(clientId, options) {
            return localVarFp.getClientLogo(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information for a specific measurement client
         * @summary Get measurement client
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementClientById(clientId, options) {
            return localVarFp.getMeasurementClientById(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * List measurement clients that the user has access to
         * @summary List measurement clients
         * @param {string} [filterAccountId] Optional parameter used to query measurement clients by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {string} [filterNameContains] Optional parameter used to search for clients where the name contains a substring (case insensitive)
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeasurementClients(filterAccountId, filterNameContains, pageSize, pageAfter, options) {
            return localVarFp.listMeasurementClients(filterAccountId, filterNameContains, pageSize, pageAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates properties of a measurement client
         * @summary Update measurement client
         * @param {string} clientId
         * @param {MeasurementClientMutation} measurementClientMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeasurementClientById(clientId, measurementClientMutation, options) {
            return localVarFp.updateMeasurementClientById(clientId, measurementClientMutation, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a logo for a client
         * @summary Upload measurement client logo
         * @param {string} clientId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientLogo(clientId, body, options) {
            return localVarFp.uploadClientLogo(clientId, body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MeasurementClientsApi - object-oriented interface
 * @export
 * @class MeasurementClientsApi
 * @extends {BaseAPI}
 */
export class MeasurementClientsApi extends BaseAPI {
    /**
     * Create a measurement client in the account of the user
     * @summary Create measurement client
     * @param {MeasurementClientMutation} measurementClientMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementClientsApi
     */
    createMeasurementClient(measurementClientMutation, options) {
        return MeasurementClientsApiFp(this.configuration).createMeasurementClient(measurementClientMutation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the logo for a client
     * @summary Delete measurement client logo
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementClientsApi
     */
    deleteClientLogo(clientId, options) {
        return MeasurementClientsApiFp(this.configuration).deleteClientLogo(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a measurement client
     * @summary Delete measurement client
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementClientsApi
     */
    deleteMeasurementClientById(clientId, options) {
        return MeasurementClientsApiFp(this.configuration).deleteMeasurementClientById(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the client logo, if the image is hosted on the Digiseg platform. Refer to the clients\'s `logo_url` to get a non-authenticated and shareable URL for the logo.
     * @summary Get measurement client logo
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementClientsApi
     */
    getClientLogo(clientId, options) {
        return MeasurementClientsApiFp(this.configuration).getClientLogo(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get information for a specific measurement client
     * @summary Get measurement client
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementClientsApi
     */
    getMeasurementClientById(clientId, options) {
        return MeasurementClientsApiFp(this.configuration).getMeasurementClientById(clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List measurement clients that the user has access to
     * @summary List measurement clients
     * @param {string} [filterAccountId] Optional parameter used to query measurement clients by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
     * @param {string} [filterNameContains] Optional parameter used to search for clients where the name contains a substring (case insensitive)
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementClientsApi
     */
    listMeasurementClients(filterAccountId, filterNameContains, pageSize, pageAfter, options) {
        return MeasurementClientsApiFp(this.configuration).listMeasurementClients(filterAccountId, filterNameContains, pageSize, pageAfter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates properties of a measurement client
     * @summary Update measurement client
     * @param {string} clientId
     * @param {MeasurementClientMutation} measurementClientMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementClientsApi
     */
    updateMeasurementClientById(clientId, measurementClientMutation, options) {
        return MeasurementClientsApiFp(this.configuration).updateMeasurementClientById(clientId, measurementClientMutation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload a logo for a client
     * @summary Upload measurement client logo
     * @param {string} clientId
     * @param {File} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementClientsApi
     */
    uploadClientLogo(clientId, body, options) {
        return MeasurementClientsApiFp(this.configuration).uploadClientLogo(clientId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MeasurementLabelsApi - axios parameter creator
 * @export
 */
export const MeasurementLabelsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * List measurement labels that the user has access to
         * @summary List measurement labels
         * @param {string} [filterAccountId] Optional parameter used to query measurement labels by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeasurementLabels: (filterAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/measurement/labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MeasurementLabelsApi - functional programming interface
 * @export
 */
export const MeasurementLabelsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MeasurementLabelsApiAxiosParamCreator(configuration);
    return {
        /**
         * List measurement labels that the user has access to
         * @summary List measurement labels
         * @param {string} [filterAccountId] Optional parameter used to query measurement labels by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeasurementLabels(filterAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMeasurementLabels(filterAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['MeasurementLabelsApi.listMeasurementLabels']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * MeasurementLabelsApi - factory interface
 * @export
 */
export const MeasurementLabelsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MeasurementLabelsApiFp(configuration);
    return {
        /**
         * List measurement labels that the user has access to
         * @summary List measurement labels
         * @param {string} [filterAccountId] Optional parameter used to query measurement labels by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeasurementLabels(filterAccountId, options) {
            return localVarFp.listMeasurementLabels(filterAccountId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MeasurementLabelsApi - object-oriented interface
 * @export
 * @class MeasurementLabelsApi
 * @extends {BaseAPI}
 */
export class MeasurementLabelsApi extends BaseAPI {
    /**
     * List measurement labels that the user has access to
     * @summary List measurement labels
     * @param {string} [filterAccountId] Optional parameter used to query measurement labels by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementLabelsApi
     */
    listMeasurementLabels(filterAccountId, options) {
        return MeasurementLabelsApiFp(this.configuration).listMeasurementLabels(filterAccountId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NonPublicApi - axios parameter creator
 * @export
 */
export const NonPublicApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Accept subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSubscriptionOffer: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('acceptSubscriptionOffer', 'offerId', offerId);
            const localVarPath = `/subscription_offers/{offer_id}/accept`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Internal endpoint used to authenticate an incoming request. The endpoint will validate the provided Access Token or API key.
         * @summary Authenticate incoming request
         * @param {string} xOriginalUri
         * @param {string} xOriginalMethod
         * @param {string} [authorization]
         * @param {string} [xAPIKEY]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateIncomingRequest: (xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xOriginalUri' is not null or undefined
            assertParamExists('authenticateIncomingRequest', 'xOriginalUri', xOriginalUri);
            // verify required parameter 'xOriginalMethod' is not null or undefined
            assertParamExists('authenticateIncomingRequest', 'xOriginalMethod', xOriginalMethod);
            const localVarPath = `/auth/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (xOriginalUri != null) {
                localVarHeaderParameter['X-Original-Uri'] = String(xOriginalUri);
            }
            if (xOriginalMethod != null) {
                localVarHeaderParameter['X-Original-Method'] = String(xOriginalMethod);
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Complete/respond to an audience recommendation
         * @param {AudienceRecommendationRequestMessage} audienceRecommendationRequestMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAudienceRecommendation: (audienceRecommendationRequestMessage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'audienceRecommendationRequestMessage' is not null or undefined
            assertParamExists('completeAudienceRecommendation', 'audienceRecommendationRequestMessage', audienceRecommendationRequestMessage);
            const localVarPath = `/taxonomy/audiences/recommendation/completion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(audienceRecommendationRequestMessage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription: (accountId, accountSubscriptionCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createAccountSubscription', 'accountId', accountId);
            // verify required parameter 'accountSubscriptionCreation' is not null or undefined
            assertParamExists('createAccountSubscription', 'accountSubscriptionCreation', accountSubscriptionCreation);
            const localVarPath = `/accounts/{account_id}/subscriptions`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accountSubscriptionCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create an access token for one or more shared resources
         * @param {ResourceSharingTokenRequest} resourceSharingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceSharingToken: (resourceSharingTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resourceSharingTokenRequest' is not null or undefined
            assertParamExists('createResourceSharingToken', 'resourceSharingTokenRequest', resourceSharingTokenRequest);
            const localVarPath = `/auth/resource_share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(resourceSharingTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Initiate a checkout session to purchase a subscription using Stripe
         * @param {string} accountId
         * @param {StripeAccountSubscriptionPurchaseCreation} stripeAccountSubscriptionPurchaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeAccountSubscriptionPurchase: (accountId, stripeAccountSubscriptionPurchaseCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createStripeAccountSubscriptionPurchase', 'accountId', accountId);
            // verify required parameter 'stripeAccountSubscriptionPurchaseCreation' is not null or undefined
            assertParamExists('createStripeAccountSubscriptionPurchase', 'stripeAccountSubscriptionPurchaseCreation', stripeAccountSubscriptionPurchaseCreation);
            const localVarPath = `/accounts/{account_id}/subscriptions/purchase/stripe`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stripeAccountSubscriptionPurchaseCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a subscription offer. Only permitted for super-admins.
         * @summary Create subscription offer
         * @param {SubscriptionOfferCreation} subscriptionOfferCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionOffer: (subscriptionOfferCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionOfferCreation' is not null or undefined
            assertParamExists('createSubscriptionOffer', 'subscriptionOfferCreation', subscriptionOfferCreation);
            const localVarPath = `/subscription_offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionOfferCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a subscription plan. Only permitted for super-admins.
         * @summary Create subscription plan
         * @param {SubscriptionPlanFull} subscriptionPlanFull
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionPlan: (subscriptionPlanFull, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionPlanFull' is not null or undefined
            assertParamExists('createSubscriptionPlan', 'subscriptionPlanFull', subscriptionPlanFull);
            const localVarPath = `/subscription_plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionPlanFull, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create user
         * @param {UserCreation} userCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: (userCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userCreation' is not null or undefined
            assertParamExists('createUser', 'userCreation', userCreation);
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountById: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccountById', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById: (accountId, subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccountSubscriptionById', 'accountId', accountId);
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('deleteAccountSubscriptionById', 'subscriptionId', subscriptionId);
            const localVarPath = `/accounts/{account_id}/subscriptions/{subscription_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingData: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/ux/user/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionOfferById: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('deleteSubscriptionOfferById', 'offerId', offerId);
            const localVarPath = `/subscription_offers/{offer_id}`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} accountId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetAccountLogo: (accountId, vrft, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAssetAccountLogo', 'accountId', accountId);
            // verify required parameter 'vrft' is not null or undefined
            assertParamExists('getAssetAccountLogo', 'vrft', vrft);
            const localVarPath = `/assets/accounts/{account_id}/logo`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (vrft !== undefined) {
                localVarQueryParameter['vrft'] = vrft;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clientId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetClientLogo: (clientId, vrft, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAssetClientLogo', 'clientId', clientId);
            // verify required parameter 'vrft' is not null or undefined
            assertParamExists('getAssetClientLogo', 'vrft', vrft);
            const localVarPath = `/assets/measurement/clients/{client_id}/logo`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (vrft !== undefined) {
                localVarQueryParameter['vrft'] = vrft;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} studyId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetStudyBannerImage: (studyId, vrft, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('getAssetStudyBannerImage', 'studyId', studyId);
            // verify required parameter 'vrft' is not null or undefined
            assertParamExists('getAssetStudyBannerImage', 'vrft', vrft);
            const localVarPath = `/assets/studies/{study_id}/banner_image`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (vrft !== undefined) {
                localVarQueryParameter['vrft'] = vrft;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetUserAvatar: (userId, vrft, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAssetUserAvatar', 'userId', userId);
            // verify required parameter 'vrft' is not null or undefined
            assertParamExists('getAssetUserAvatar', 'vrft', vrft);
            const localVarPath = `/assets/users/{user_id}/avatar`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (vrft !== undefined) {
                localVarQueryParameter['vrft'] = vrft;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint provides a set of example IP addresses that can be used to explore and demonstrate the Audience API capabilities.
         * @summary Get example IP addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExampleIps: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/audiences/examples`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingData: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/ux/user/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the source data of an population
         * @summary Get source data of population
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationSource: (categoryKey, populationKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryKey' is not null or undefined
            assertParamExists('getPopuplationSource', 'categoryKey', categoryKey);
            // verify required parameter 'populationKey' is not null or undefined
            assertParamExists('getPopuplationSource', 'populationKey', populationKey);
            const localVarPath = `/populations/{category_key}/{population_key}/source`
                .replace(`{${"category_key"}}`, encodeURIComponent(String(categoryKey)))
                .replace(`{${"population_key"}}`, encodeURIComponent(String(populationKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get information about an account registration. Only accessible to super admins.
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationById: (registrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('getRegistrationById', 'registrationId', registrationId);
            const localVarPath = `/registrations/{registration_id}`
                .replace(`{${"registration_id"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportAsset: (studyId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('getSharedReportAsset', 'studyId', studyId);
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getSharedReportAsset', 'reportId', reportId);
            const localVarPath = `/assets/studies/{study_id}/shared_report/{report_id}`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets billing information in Stripe for an account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeBillingInfo: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getStripeBillingInfo', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/subscriptions/billing/stripe`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionOfferById: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('getSubscriptionOfferById', 'offerId', offerId);
            const localVarPath = `/subscription_offers/{offer_id}`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets a specific subscription plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPlanById: (planId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('getSubscriptionPlanById', 'planId', planId);
            const localVarPath = `/subscription_plans/{plan_id}`
                .replace(`{${"plan_id"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Leave feedback for the product team
         * @param {CustomerCommunicationMessage} customerCommunicationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveFeedback: (customerCommunicationMessage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerCommunicationMessage' is not null or undefined
            assertParamExists('leaveFeedback', 'customerCommunicationMessage', customerCommunicationMessage);
            const localVarPath = `/communications/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customerCommunicationMessage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List accounts
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {string} [filterNameContains] Optional parameter used to search for accounts where the name contains a substring (case insensitive)
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {AccountSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts: (pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            if (filterNameContains !== undefined) {
                localVarQueryParameter['filter[name][contains]'] = filterNameContains;
            }
            if (filterCreatedAtAfter !== undefined) {
                localVarQueryParameter['filter[created_at][after]'] = (filterCreatedAtAfter instanceof Date) ?
                    filterCreatedAtAfter.toISOString() :
                    filterCreatedAtAfter;
            }
            if (filterCreatedAtBefore !== undefined) {
                localVarQueryParameter['filter[created_at][before]'] = (filterCreatedAtBefore instanceof Date) ?
                    filterCreatedAtBefore.toISOString() :
                    filterCreatedAtBefore;
            }
            if (filterCreatedByAfter !== undefined) {
                localVarQueryParameter['filter[created_by][after]'] = (filterCreatedByAfter instanceof Date) ?
                    filterCreatedByAfter.toISOString() :
                    filterCreatedByAfter;
            }
            if (filterCreatedByBefore !== undefined) {
                localVarQueryParameter['filter[created_by][before]'] = (filterCreatedByBefore instanceof Date) ?
                    filterCreatedByBefore.toISOString() :
                    filterCreatedByBefore;
            }
            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List users
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. &#x60;super_admin&#x60;
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterAccountId] Filter based on the user\&#39;s account
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: (filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterPlatformRoles !== undefined) {
                localVarQueryParameter['filter[platform_roles]'] = filterPlatformRoles;
            }
            if (filterAccountRoles !== undefined) {
                localVarQueryParameter['filter[account_roles]'] = filterAccountRoles;
            }
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            if (filterNameContains !== undefined) {
                localVarQueryParameter['filter[name][contains]'] = filterNameContains;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Query the OLAP data for a study
         * @param {string} studyId
         * @param {StudyOlapQuery} studyOlapQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyOlapData: (studyId, studyOlapQuery, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('queryStudyOlapData', 'studyId', studyId);
            // verify required parameter 'studyOlapQuery' is not null or undefined
            assertParamExists('queryStudyOlapData', 'studyOlapQuery', studyOlapQuery);
            const localVarPath = `/studies/{study_id}/stats/olap_query`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(studyOlapQuery, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Raise an issue with Digiseg support
         * @param {CustomerCommunicationMessage} customerCommunicationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSupport: (customerCommunicationMessage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerCommunicationMessage' is not null or undefined
            assertParamExists('requestSupport', 'customerCommunicationMessage', customerCommunicationMessage);
            const localVarPath = `/communications/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customerCommunicationMessage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Save key-value data for user onboarding
         * @param {{ [key: string]: string; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingData: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('saveOnboardingData', 'requestBody', requestBody);
            const localVarPath = `/ux/user/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Internal endpoint to send emails through the platform. Note that this (synchronous) way of sending emails is discouraged - you can also send emails by posting the request object as JSON to the designated Kafka topic for this.
         * @summary Send emails
         * @param {SendEmailQuery} sendEmailQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmails: (sendEmailQuery, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sendEmailQuery' is not null or undefined
            assertParamExists('sendEmails', 'sendEmailQuery', sendEmailQuery);
            const localVarPath = `/communications/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailQuery, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync account information with Stripe
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncAccount: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('stripeSyncAccount', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/sync/stripe`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync subscription plan information with Stripe
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncSubscriptionPlan: (planId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('stripeSyncSubscriptionPlan', 'planId', planId);
            const localVarPath = `/subscription_plans/{plan_id}/sync/stripe`
                .replace(`{${"plan_id"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Start the authentication process using passwordless auth. This process starts with sending a one-time password (OTP) to the user with the provided email address.
         * @summary Submit passwordless auth flow
         * @param {PasswordlessAuthRequest} passwordlessAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPasswordlessAuth: (passwordlessAuthRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'passwordlessAuthRequest' is not null or undefined
            assertParamExists('submitPasswordlessAuth', 'passwordlessAuthRequest', passwordlessAuthRequest);
            const localVarPath = `/auth/passwordless`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(passwordlessAuthRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Start the account registration process, which starts with verifying the authenticity of the user\'s email address. Upon verification, an account and user will be created.
         * @summary Submit account registration flow
         * @param {RegistrationRequest} registrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitRegistration: (registrationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registrationRequest' is not null or undefined
            assertParamExists('submitRegistration', 'registrationRequest', registrationRequest);
            const localVarPath = `/auth/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registrationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync active studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncActiveStudiesWithKafka: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/studies/sync/kafka/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync deleted studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDeletedStudiesWithKafka: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/studies/sync/kafka/deleted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync inactive studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInactiveStudiesWithKafka: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/studies/sync/kafka/inactive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update subscription plan
         * @param {string} planId
         * @param {SubscriptionPlanMutation} subscriptionPlanMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPlanById: (planId, subscriptionPlanMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('updateSubscriptionPlanById', 'planId', planId);
            // verify required parameter 'subscriptionPlanMutation' is not null or undefined
            assertParamExists('updateSubscriptionPlanById', 'subscriptionPlanMutation', subscriptionPlanMutation);
            const localVarPath = `/subscription_plans/{plan_id}`
                .replace(`{${"plan_id"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionPlanMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify account registration
         * @param {string} registrationId
         * @param {string} verificationCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration: (registrationId, verificationCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('verifyRegistration', 'registrationId', registrationId);
            // verify required parameter 'verificationCode' is not null or undefined
            assertParamExists('verifyRegistration', 'verificationCode', verificationCode);
            const localVarPath = `/auth/verify_registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (registrationId !== undefined) {
                localVarQueryParameter['registration_id'] = registrationId;
            }
            if (verificationCode !== undefined) {
                localVarQueryParameter['verification_code'] = verificationCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NonPublicApi - functional programming interface
 * @export
 */
export const NonPublicApiFp = function (configuration) {
    const localVarAxiosParamCreator = NonPublicApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Accept subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSubscriptionOffer(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.acceptSubscriptionOffer(offerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.acceptSubscriptionOffer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Internal endpoint used to authenticate an incoming request. The endpoint will validate the provided Access Token or API key.
         * @summary Authenticate incoming request
         * @param {string} xOriginalUri
         * @param {string} xOriginalMethod
         * @param {string} [authorization]
         * @param {string} [xAPIKEY]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.authenticateIncomingRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Complete/respond to an audience recommendation
         * @param {AudienceRecommendationRequestMessage} audienceRecommendationRequestMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAudienceRecommendation(audienceRecommendationRequestMessage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeAudienceRecommendation(audienceRecommendationRequestMessage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.completeAudienceRecommendation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription(accountId, accountSubscriptionCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccountSubscription(accountId, accountSubscriptionCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.createAccountSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create an access token for one or more shared resources
         * @param {ResourceSharingTokenRequest} resourceSharingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceSharingToken(resourceSharingTokenRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createResourceSharingToken(resourceSharingTokenRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.createResourceSharingToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Initiate a checkout session to purchase a subscription using Stripe
         * @param {string} accountId
         * @param {StripeAccountSubscriptionPurchaseCreation} stripeAccountSubscriptionPurchaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.createStripeAccountSubscriptionPurchase']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a subscription offer. Only permitted for super-admins.
         * @summary Create subscription offer
         * @param {SubscriptionOfferCreation} subscriptionOfferCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionOffer(subscriptionOfferCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSubscriptionOffer(subscriptionOfferCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.createSubscriptionOffer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a subscription plan. Only permitted for super-admins.
         * @summary Create subscription plan
         * @param {SubscriptionPlanFull} subscriptionPlanFull
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionPlan(subscriptionPlanFull, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSubscriptionPlan(subscriptionPlanFull, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.createSubscriptionPlan']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create user
         * @param {UserCreation} userCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUser(userCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.createUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountById(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccountById(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.deleteAccountById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById(accountId, subscriptionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccountSubscriptionById(accountId, subscriptionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.deleteAccountSubscriptionById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingData(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOnboardingData(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.deleteOnboardingData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionOfferById(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSubscriptionOfferById(offerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.deleteSubscriptionOfferById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} accountId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetAccountLogo(accountId, vrft, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssetAccountLogo(accountId, vrft, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getAssetAccountLogo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} clientId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetClientLogo(clientId, vrft, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssetClientLogo(clientId, vrft, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getAssetClientLogo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} studyId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetStudyBannerImage(studyId, vrft, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssetStudyBannerImage(studyId, vrft, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getAssetStudyBannerImage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} userId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetUserAvatar(userId, vrft, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssetUserAvatar(userId, vrft, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getAssetUserAvatar']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * This endpoint provides a set of example IP addresses that can be used to explore and demonstrate the Audience API capabilities.
         * @summary Get example IP addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExampleIps(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExampleIps(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getExampleIps']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingData(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOnboardingData(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getOnboardingData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get the source data of an population
         * @summary Get source data of population
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationSource(categoryKey, populationKey, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPopuplationSource(categoryKey, populationKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getPopuplationSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get information about an account registration. Only accessible to super admins.
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationById(registrationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRegistrationById(registrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getRegistrationById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportAsset(studyId, reportId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSharedReportAsset(studyId, reportId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getSharedReportAsset']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Gets billing information in Stripe for an account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeBillingInfo(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStripeBillingInfo(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getStripeBillingInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionOfferById(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionOfferById(offerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getSubscriptionOfferById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Gets a specific subscription plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPlanById(planId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionPlanById(planId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.getSubscriptionPlanById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Leave feedback for the product team
         * @param {CustomerCommunicationMessage} customerCommunicationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveFeedback(customerCommunicationMessage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leaveFeedback(customerCommunicationMessage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.leaveFeedback']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List accounts
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {string} [filterNameContains] Optional parameter used to search for accounts where the name contains a substring (case insensitive)
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {AccountSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.listAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List users
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. &#x60;super_admin&#x60;
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterAccountId] Filter based on the user\&#39;s account
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.listUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Query the OLAP data for a study
         * @param {string} studyId
         * @param {StudyOlapQuery} studyOlapQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyOlapData(studyId, studyOlapQuery, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryStudyOlapData(studyId, studyOlapQuery, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.queryStudyOlapData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Raise an issue with Digiseg support
         * @param {CustomerCommunicationMessage} customerCommunicationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSupport(customerCommunicationMessage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestSupport(customerCommunicationMessage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.requestSupport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Save key-value data for user onboarding
         * @param {{ [key: string]: string; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingData(requestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveOnboardingData(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.saveOnboardingData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Internal endpoint to send emails through the platform. Note that this (synchronous) way of sending emails is discouraged - you can also send emails by posting the request object as JSON to the designated Kafka topic for this.
         * @summary Send emails
         * @param {SendEmailQuery} sendEmailQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmails(sendEmailQuery, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendEmails(sendEmailQuery, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.sendEmails']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sync account information with Stripe
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncAccount(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.stripeSyncAccount(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.stripeSyncAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sync subscription plan information with Stripe
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncSubscriptionPlan(planId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.stripeSyncSubscriptionPlan(planId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.stripeSyncSubscriptionPlan']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Start the authentication process using passwordless auth. This process starts with sending a one-time password (OTP) to the user with the provided email address.
         * @summary Submit passwordless auth flow
         * @param {PasswordlessAuthRequest} passwordlessAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPasswordlessAuth(passwordlessAuthRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitPasswordlessAuth(passwordlessAuthRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.submitPasswordlessAuth']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Start the account registration process, which starts with verifying the authenticity of the user\'s email address. Upon verification, an account and user will be created.
         * @summary Submit account registration flow
         * @param {RegistrationRequest} registrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitRegistration(registrationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitRegistration(registrationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.submitRegistration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sync active studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncActiveStudiesWithKafka(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncActiveStudiesWithKafka(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.syncActiveStudiesWithKafka']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sync deleted studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDeletedStudiesWithKafka(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncDeletedStudiesWithKafka(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.syncDeletedStudiesWithKafka']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sync inactive studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInactiveStudiesWithKafka(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncInactiveStudiesWithKafka(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.syncInactiveStudiesWithKafka']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update subscription plan
         * @param {string} planId
         * @param {SubscriptionPlanMutation} subscriptionPlanMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPlanById(planId, subscriptionPlanMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSubscriptionPlanById(planId, subscriptionPlanMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.updateSubscriptionPlanById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Verify account registration
         * @param {string} registrationId
         * @param {string} verificationCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration(registrationId, verificationCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyRegistration(registrationId, verificationCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NonPublicApi.verifyRegistration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * NonPublicApi - factory interface
 * @export
 */
export const NonPublicApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NonPublicApiFp(configuration);
    return {
        /**
         *
         * @summary Accept subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSubscriptionOffer(offerId, options) {
            return localVarFp.acceptSubscriptionOffer(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Internal endpoint used to authenticate an incoming request. The endpoint will validate the provided Access Token or API key.
         * @summary Authenticate incoming request
         * @param {string} xOriginalUri
         * @param {string} xOriginalMethod
         * @param {string} [authorization]
         * @param {string} [xAPIKEY]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options) {
            return localVarFp.authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Complete/respond to an audience recommendation
         * @param {AudienceRecommendationRequestMessage} audienceRecommendationRequestMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAudienceRecommendation(audienceRecommendationRequestMessage, options) {
            return localVarFp.completeAudienceRecommendation(audienceRecommendationRequestMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription(accountId, accountSubscriptionCreation, options) {
            return localVarFp.createAccountSubscription(accountId, accountSubscriptionCreation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an access token for one or more shared resources
         * @param {ResourceSharingTokenRequest} resourceSharingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResourceSharingToken(resourceSharingTokenRequest, options) {
            return localVarFp.createResourceSharingToken(resourceSharingTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Initiate a checkout session to purchase a subscription using Stripe
         * @param {string} accountId
         * @param {StripeAccountSubscriptionPurchaseCreation} stripeAccountSubscriptionPurchaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options) {
            return localVarFp.createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a subscription offer. Only permitted for super-admins.
         * @summary Create subscription offer
         * @param {SubscriptionOfferCreation} subscriptionOfferCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionOffer(subscriptionOfferCreation, options) {
            return localVarFp.createSubscriptionOffer(subscriptionOfferCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a subscription plan. Only permitted for super-admins.
         * @summary Create subscription plan
         * @param {SubscriptionPlanFull} subscriptionPlanFull
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionPlan(subscriptionPlanFull, options) {
            return localVarFp.createSubscriptionPlan(subscriptionPlanFull, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create user
         * @param {UserCreation} userCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreation, options) {
            return localVarFp.createUser(userCreation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountById(accountId, options) {
            return localVarFp.deleteAccountById(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById(accountId, subscriptionId, options) {
            return localVarFp.deleteAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingData(options) {
            return localVarFp.deleteOnboardingData(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionOfferById(offerId, options) {
            return localVarFp.deleteSubscriptionOfferById(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} accountId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetAccountLogo(accountId, vrft, options) {
            return localVarFp.getAssetAccountLogo(accountId, vrft, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clientId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetClientLogo(clientId, vrft, options) {
            return localVarFp.getAssetClientLogo(clientId, vrft, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} studyId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetStudyBannerImage(studyId, vrft, options) {
            return localVarFp.getAssetStudyBannerImage(studyId, vrft, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {string} vrft Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetUserAvatar(userId, vrft, options) {
            return localVarFp.getAssetUserAvatar(userId, vrft, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint provides a set of example IP addresses that can be used to explore and demonstrate the Audience API capabilities.
         * @summary Get example IP addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExampleIps(options) {
            return localVarFp.getExampleIps(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingData(options) {
            return localVarFp.getOnboardingData(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the source data of an population
         * @summary Get source data of population
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationSource(categoryKey, populationKey, options) {
            return localVarFp.getPopuplationSource(categoryKey, populationKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information about an account registration. Only accessible to super admins.
         * @param {string} registrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationById(registrationId, options) {
            return localVarFp.getRegistrationById(registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportAsset(studyId, reportId, options) {
            return localVarFp.getSharedReportAsset(studyId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets billing information in Stripe for an account
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeBillingInfo(accountId, options) {
            return localVarFp.getStripeBillingInfo(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionOfferById(offerId, options) {
            return localVarFp.getSubscriptionOfferById(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a specific subscription plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPlanById(planId, options) {
            return localVarFp.getSubscriptionPlanById(planId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Leave feedback for the product team
         * @param {CustomerCommunicationMessage} customerCommunicationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveFeedback(customerCommunicationMessage, options) {
            return localVarFp.leaveFeedback(customerCommunicationMessage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List accounts
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {string} [filterNameContains] Optional parameter used to search for accounts where the name contains a substring (case insensitive)
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByAfter] Optional parameter used to search for accounts created after the specified date-time
         * @param {string} [filterCreatedByBefore] Optional parameter used to search for accounts created after the specified date-time
         * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {AccountSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options) {
            return localVarFp.listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List users
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. &#x60;super_admin&#x60;
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterAccountId] Filter based on the user\&#39;s account
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options) {
            return localVarFp.listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Query the OLAP data for a study
         * @param {string} studyId
         * @param {StudyOlapQuery} studyOlapQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyOlapData(studyId, studyOlapQuery, options) {
            return localVarFp.queryStudyOlapData(studyId, studyOlapQuery, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Raise an issue with Digiseg support
         * @param {CustomerCommunicationMessage} customerCommunicationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSupport(customerCommunicationMessage, options) {
            return localVarFp.requestSupport(customerCommunicationMessage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Save key-value data for user onboarding
         * @param {{ [key: string]: string; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingData(requestBody, options) {
            return localVarFp.saveOnboardingData(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Internal endpoint to send emails through the platform. Note that this (synchronous) way of sending emails is discouraged - you can also send emails by posting the request object as JSON to the designated Kafka topic for this.
         * @summary Send emails
         * @param {SendEmailQuery} sendEmailQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmails(sendEmailQuery, options) {
            return localVarFp.sendEmails(sendEmailQuery, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync account information with Stripe
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncAccount(accountId, options) {
            return localVarFp.stripeSyncAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync subscription plan information with Stripe
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncSubscriptionPlan(planId, options) {
            return localVarFp.stripeSyncSubscriptionPlan(planId, options).then((request) => request(axios, basePath));
        },
        /**
         * Start the authentication process using passwordless auth. This process starts with sending a one-time password (OTP) to the user with the provided email address.
         * @summary Submit passwordless auth flow
         * @param {PasswordlessAuthRequest} passwordlessAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPasswordlessAuth(passwordlessAuthRequest, options) {
            return localVarFp.submitPasswordlessAuth(passwordlessAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start the account registration process, which starts with verifying the authenticity of the user\'s email address. Upon verification, an account and user will be created.
         * @summary Submit account registration flow
         * @param {RegistrationRequest} registrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitRegistration(registrationRequest, options) {
            return localVarFp.submitRegistration(registrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync active studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncActiveStudiesWithKafka(options) {
            return localVarFp.syncActiveStudiesWithKafka(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync deleted studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDeletedStudiesWithKafka(options) {
            return localVarFp.syncDeletedStudiesWithKafka(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync inactive studies to Kafka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInactiveStudiesWithKafka(options) {
            return localVarFp.syncInactiveStudiesWithKafka(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update subscription plan
         * @param {string} planId
         * @param {SubscriptionPlanMutation} subscriptionPlanMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPlanById(planId, subscriptionPlanMutation, options) {
            return localVarFp.updateSubscriptionPlanById(planId, subscriptionPlanMutation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify account registration
         * @param {string} registrationId
         * @param {string} verificationCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration(registrationId, verificationCode, options) {
            return localVarFp.verifyRegistration(registrationId, verificationCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NonPublicApi - object-oriented interface
 * @export
 * @class NonPublicApi
 * @extends {BaseAPI}
 */
export class NonPublicApi extends BaseAPI {
    /**
     *
     * @summary Accept subscription offer
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    acceptSubscriptionOffer(offerId, options) {
        return NonPublicApiFp(this.configuration).acceptSubscriptionOffer(offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Internal endpoint used to authenticate an incoming request. The endpoint will validate the provided Access Token or API key.
     * @summary Authenticate incoming request
     * @param {string} xOriginalUri
     * @param {string} xOriginalMethod
     * @param {string} [authorization]
     * @param {string} [xAPIKEY]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options) {
        return NonPublicApiFp(this.configuration).authenticateIncomingRequest(xOriginalUri, xOriginalMethod, authorization, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Complete/respond to an audience recommendation
     * @param {AudienceRecommendationRequestMessage} audienceRecommendationRequestMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    completeAudienceRecommendation(audienceRecommendationRequestMessage, options) {
        return NonPublicApiFp(this.configuration).completeAudienceRecommendation(audienceRecommendationRequestMessage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a subscription on an account. Only permitted for super-admins.
     * @summary Create account subscription
     * @param {string} accountId
     * @param {AccountSubscriptionCreation} accountSubscriptionCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    createAccountSubscription(accountId, accountSubscriptionCreation, options) {
        return NonPublicApiFp(this.configuration).createAccountSubscription(accountId, accountSubscriptionCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an access token for one or more shared resources
     * @param {ResourceSharingTokenRequest} resourceSharingTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    createResourceSharingToken(resourceSharingTokenRequest, options) {
        return NonPublicApiFp(this.configuration).createResourceSharingToken(resourceSharingTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Initiate a checkout session to purchase a subscription using Stripe
     * @param {string} accountId
     * @param {StripeAccountSubscriptionPurchaseCreation} stripeAccountSubscriptionPurchaseCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options) {
        return NonPublicApiFp(this.configuration).createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a subscription offer. Only permitted for super-admins.
     * @summary Create subscription offer
     * @param {SubscriptionOfferCreation} subscriptionOfferCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    createSubscriptionOffer(subscriptionOfferCreation, options) {
        return NonPublicApiFp(this.configuration).createSubscriptionOffer(subscriptionOfferCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a subscription plan. Only permitted for super-admins.
     * @summary Create subscription plan
     * @param {SubscriptionPlanFull} subscriptionPlanFull
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    createSubscriptionPlan(subscriptionPlanFull, options) {
        return NonPublicApiFp(this.configuration).createSubscriptionPlan(subscriptionPlanFull, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create user
     * @param {UserCreation} userCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    createUser(userCreation, options) {
        return NonPublicApiFp(this.configuration).createUser(userCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete account
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    deleteAccountById(accountId, options) {
        return NonPublicApiFp(this.configuration).deleteAccountById(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a subscription on an account. Only permitted for super-admins.
     * @summary Delete account subscription
     * @param {string} accountId
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    deleteAccountSubscriptionById(accountId, subscriptionId, options) {
        return NonPublicApiFp(this.configuration).deleteAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete key-value data for user onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    deleteOnboardingData(options) {
        return NonPublicApiFp(this.configuration).deleteOnboardingData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete subscription offer
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    deleteSubscriptionOfferById(offerId, options) {
        return NonPublicApiFp(this.configuration).deleteSubscriptionOfferById(offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} accountId
     * @param {string} vrft Verification token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getAssetAccountLogo(accountId, vrft, options) {
        return NonPublicApiFp(this.configuration).getAssetAccountLogo(accountId, vrft, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} clientId
     * @param {string} vrft Verification token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getAssetClientLogo(clientId, vrft, options) {
        return NonPublicApiFp(this.configuration).getAssetClientLogo(clientId, vrft, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} studyId
     * @param {string} vrft Verification token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getAssetStudyBannerImage(studyId, vrft, options) {
        return NonPublicApiFp(this.configuration).getAssetStudyBannerImage(studyId, vrft, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} userId
     * @param {string} vrft Verification token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getAssetUserAvatar(userId, vrft, options) {
        return NonPublicApiFp(this.configuration).getAssetUserAvatar(userId, vrft, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint provides a set of example IP addresses that can be used to explore and demonstrate the Audience API capabilities.
     * @summary Get example IP addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getExampleIps(options) {
        return NonPublicApiFp(this.configuration).getExampleIps(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get key-value data for user onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getOnboardingData(options) {
        return NonPublicApiFp(this.configuration).getOnboardingData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the source data of an population
     * @summary Get source data of population
     * @param {string} categoryKey An identifier for the category
     * @param {string} populationKey An identifier for the population
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getPopuplationSource(categoryKey, populationKey, options) {
        return NonPublicApiFp(this.configuration).getPopuplationSource(categoryKey, populationKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get information about an account registration. Only accessible to super admins.
     * @param {string} registrationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getRegistrationById(registrationId, options) {
        return NonPublicApiFp(this.configuration).getRegistrationById(registrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} studyId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getSharedReportAsset(studyId, reportId, options) {
        return NonPublicApiFp(this.configuration).getSharedReportAsset(studyId, reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets billing information in Stripe for an account
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getStripeBillingInfo(accountId, options) {
        return NonPublicApiFp(this.configuration).getStripeBillingInfo(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get subscription offer
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getSubscriptionOfferById(offerId, options) {
        return NonPublicApiFp(this.configuration).getSubscriptionOfferById(offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a specific subscription plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    getSubscriptionPlanById(planId, options) {
        return NonPublicApiFp(this.configuration).getSubscriptionPlanById(planId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Leave feedback for the product team
     * @param {CustomerCommunicationMessage} customerCommunicationMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    leaveFeedback(customerCommunicationMessage, options) {
        return NonPublicApiFp(this.configuration).leaveFeedback(customerCommunicationMessage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List accounts
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {string} [filterNameContains] Optional parameter used to search for accounts where the name contains a substring (case insensitive)
     * @param {string} [filterCreatedAtAfter] Optional parameter used to search for accounts created after the specified date-time
     * @param {string} [filterCreatedAtBefore] Optional parameter used to search for accounts created after the specified date-time
     * @param {string} [filterCreatedByAfter] Optional parameter used to search for accounts created after the specified date-time
     * @param {string} [filterCreatedByBefore] Optional parameter used to search for accounts created after the specified date-time
     * @param {Array<AccountIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
     * @param {AccountSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options) {
        return NonPublicApiFp(this.configuration).listAccounts(pageSize, pageAfter, filterNameContains, filterCreatedAtAfter, filterCreatedAtBefore, filterCreatedByAfter, filterCreatedByBefore, include, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List users
     * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. &#x60;super_admin&#x60;
     * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
     * @param {string} [filterAccountId] Filter based on the user\&#39;s account
     * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
     * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options) {
        return NonPublicApiFp(this.configuration).listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Query the OLAP data for a study
     * @param {string} studyId
     * @param {StudyOlapQuery} studyOlapQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    queryStudyOlapData(studyId, studyOlapQuery, options) {
        return NonPublicApiFp(this.configuration).queryStudyOlapData(studyId, studyOlapQuery, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Raise an issue with Digiseg support
     * @param {CustomerCommunicationMessage} customerCommunicationMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    requestSupport(customerCommunicationMessage, options) {
        return NonPublicApiFp(this.configuration).requestSupport(customerCommunicationMessage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Save key-value data for user onboarding
     * @param {{ [key: string]: string; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    saveOnboardingData(requestBody, options) {
        return NonPublicApiFp(this.configuration).saveOnboardingData(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Internal endpoint to send emails through the platform. Note that this (synchronous) way of sending emails is discouraged - you can also send emails by posting the request object as JSON to the designated Kafka topic for this.
     * @summary Send emails
     * @param {SendEmailQuery} sendEmailQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    sendEmails(sendEmailQuery, options) {
        return NonPublicApiFp(this.configuration).sendEmails(sendEmailQuery, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync account information with Stripe
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    stripeSyncAccount(accountId, options) {
        return NonPublicApiFp(this.configuration).stripeSyncAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync subscription plan information with Stripe
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    stripeSyncSubscriptionPlan(planId, options) {
        return NonPublicApiFp(this.configuration).stripeSyncSubscriptionPlan(planId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Start the authentication process using passwordless auth. This process starts with sending a one-time password (OTP) to the user with the provided email address.
     * @summary Submit passwordless auth flow
     * @param {PasswordlessAuthRequest} passwordlessAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    submitPasswordlessAuth(passwordlessAuthRequest, options) {
        return NonPublicApiFp(this.configuration).submitPasswordlessAuth(passwordlessAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Start the account registration process, which starts with verifying the authenticity of the user\'s email address. Upon verification, an account and user will be created.
     * @summary Submit account registration flow
     * @param {RegistrationRequest} registrationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    submitRegistration(registrationRequest, options) {
        return NonPublicApiFp(this.configuration).submitRegistration(registrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync active studies to Kafka
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    syncActiveStudiesWithKafka(options) {
        return NonPublicApiFp(this.configuration).syncActiveStudiesWithKafka(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync deleted studies to Kafka
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    syncDeletedStudiesWithKafka(options) {
        return NonPublicApiFp(this.configuration).syncDeletedStudiesWithKafka(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync inactive studies to Kafka
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    syncInactiveStudiesWithKafka(options) {
        return NonPublicApiFp(this.configuration).syncInactiveStudiesWithKafka(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update subscription plan
     * @param {string} planId
     * @param {SubscriptionPlanMutation} subscriptionPlanMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    updateSubscriptionPlanById(planId, subscriptionPlanMutation, options) {
        return NonPublicApiFp(this.configuration).updateSubscriptionPlanById(planId, subscriptionPlanMutation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify account registration
     * @param {string} registrationId
     * @param {string} verificationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonPublicApi
     */
    verifyRegistration(registrationId, verificationCode, options) {
        return NonPublicApiFp(this.configuration).verifyRegistration(registrationId, verificationCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PopulationsApi - axios parameter creator
 * @export
 */
export const PopulationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get population data referenced by a specific key.
         * @summary Get Population by key
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationByKey: (categoryKey, populationKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryKey' is not null or undefined
            assertParamExists('getPopuplationByKey', 'categoryKey', categoryKey);
            // verify required parameter 'populationKey' is not null or undefined
            assertParamExists('getPopuplationByKey', 'populationKey', populationKey);
            const localVarPath = `/populations/{category_key}/{population_key}`
                .replace(`{${"category_key"}}`, encodeURIComponent(String(categoryKey)))
                .replace(`{${"population_key"}}`, encodeURIComponent(String(populationKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the source data of an population
         * @summary Get source data of population
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationSource: (categoryKey, populationKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryKey' is not null or undefined
            assertParamExists('getPopuplationSource', 'categoryKey', categoryKey);
            // verify required parameter 'populationKey' is not null or undefined
            assertParamExists('getPopuplationSource', 'populationKey', populationKey);
            const localVarPath = `/populations/{category_key}/{population_key}/source`
                .replace(`{${"category_key"}}`, encodeURIComponent(String(categoryKey)))
                .replace(`{${"population_key"}}`, encodeURIComponent(String(populationKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List all populations within a category
         * @summary List populations of category
         * @param {string} categoryKey An identifier for the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPopuplations: (categoryKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryKey' is not null or undefined
            assertParamExists('listPopuplations', 'categoryKey', categoryKey);
            const localVarPath = `/populations/{category_key}`
                .replace(`{${"category_key"}}`, encodeURIComponent(String(categoryKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PopulationsApi - functional programming interface
 * @export
 */
export const PopulationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PopulationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get population data referenced by a specific key.
         * @summary Get Population by key
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationByKey(categoryKey, populationKey, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPopuplationByKey(categoryKey, populationKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PopulationsApi.getPopuplationByKey']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get the source data of an population
         * @summary Get source data of population
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationSource(categoryKey, populationKey, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPopuplationSource(categoryKey, populationKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PopulationsApi.getPopuplationSource']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List all populations within a category
         * @summary List populations of category
         * @param {string} categoryKey An identifier for the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPopuplations(categoryKey, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPopuplations(categoryKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PopulationsApi.listPopuplations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * PopulationsApi - factory interface
 * @export
 */
export const PopulationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PopulationsApiFp(configuration);
    return {
        /**
         * Get population data referenced by a specific key.
         * @summary Get Population by key
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationByKey(categoryKey, populationKey, options) {
            return localVarFp.getPopuplationByKey(categoryKey, populationKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the source data of an population
         * @summary Get source data of population
         * @param {string} categoryKey An identifier for the category
         * @param {string} populationKey An identifier for the population
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopuplationSource(categoryKey, populationKey, options) {
            return localVarFp.getPopuplationSource(categoryKey, populationKey, options).then((request) => request(axios, basePath));
        },
        /**
         * List all populations within a category
         * @summary List populations of category
         * @param {string} categoryKey An identifier for the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPopuplations(categoryKey, options) {
            return localVarFp.listPopuplations(categoryKey, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PopulationsApi - object-oriented interface
 * @export
 * @class PopulationsApi
 * @extends {BaseAPI}
 */
export class PopulationsApi extends BaseAPI {
    /**
     * Get population data referenced by a specific key.
     * @summary Get Population by key
     * @param {string} categoryKey An identifier for the category
     * @param {string} populationKey An identifier for the population
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationsApi
     */
    getPopuplationByKey(categoryKey, populationKey, options) {
        return PopulationsApiFp(this.configuration).getPopuplationByKey(categoryKey, populationKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the source data of an population
     * @summary Get source data of population
     * @param {string} categoryKey An identifier for the category
     * @param {string} populationKey An identifier for the population
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationsApi
     */
    getPopuplationSource(categoryKey, populationKey, options) {
        return PopulationsApiFp(this.configuration).getPopuplationSource(categoryKey, populationKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List all populations within a category
     * @summary List populations of category
     * @param {string} categoryKey An identifier for the category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationsApi
     */
    listPopuplations(categoryKey, options) {
        return PopulationsApiFp(this.configuration).listPopuplations(categoryKey, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * StudiesApi - axios parameter creator
 * @export
 */
export const StudiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create shared report
         * @param {string} studyId
         * @param {SharedReportCreation} sharedReportCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSharedReport: (studyId, sharedReportCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('createSharedReport', 'studyId', studyId);
            // verify required parameter 'sharedReportCreation' is not null or undefined
            assertParamExists('createSharedReport', 'sharedReportCreation', sharedReportCreation);
            const localVarPath = `/studies/{study_id}/shared_reports`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sharedReportCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a new study
         * @summary Create study
         * @param {StudyCreation} studyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudy: (studyCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyCreation' is not null or undefined
            assertParamExists('createStudy', 'studyCreation', studyCreation);
            const localVarPath = `/studies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(studyCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create an event (such as an impression or click) and ingest it into the study.
         * @summary Create study event
         * @param {string} studyId
         * @param {StudyEventCreation} studyEventCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudyEvent: (studyId, studyEventCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('createStudyEvent', 'studyId', studyId);
            // verify required parameter 'studyEventCreation' is not null or undefined
            assertParamExists('createStudyEvent', 'studyEventCreation', studyEventCreation);
            const localVarPath = `/studies/{study_id}/events`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(studyEventCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete shared report
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSharedReportById: (studyId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('deleteSharedReportById', 'studyId', studyId);
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('deleteSharedReportById', 'reportId', reportId);
            const localVarPath = `/studies/{study_id}/shared_reports/{report_id}`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes the banner image for a study
         * @summary Delete study banner image logo
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStudyBannerImage: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('deleteStudyBannerImage', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/assets/banner_image`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a study
         * @summary Delete study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStudyById: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('deleteStudyById', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportAsset: (studyId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('getSharedReportAsset', 'studyId', studyId);
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getSharedReportAsset', 'reportId', reportId);
            const localVarPath = `/assets/studies/{study_id}/shared_report/{report_id}`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get shared report
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportById: (studyId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('getSharedReportById', 'studyId', studyId);
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getSharedReportById', 'reportId', reportId);
            const localVarPath = `/studies/{study_id}/shared_reports/{report_id}`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)))
                .replace(`{${"report_id"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the study banner image, if the image is hosted on the Digiseg platform. Refer to the study\'s `banner_image_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get study banner image
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyBannerImage: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('getStudyBannerImage', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/assets/banner_image`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get study information for a specific study
         * @summary Get study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyById: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('getStudyById', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get shared reports for a study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharedReportsByStudyId: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('listSharedReportsByStudyId', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/shared_reports`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List studies that the user has access to
         * @summary List studies
         * @param {ListStudiesSortEnum} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {StudyLifecycleStage} [filterLifeCycleStage] Optional parameter used to filter studies by their life cycle stage
         * @param {boolean} [filterIsExample] Optional parameter used to filter for example studies
         * @param {string} [filterLabel] Optional parameter used to filter by study label
         * @param {string} [filterNameContains] Optional parameter used to search for studies where the name contains a substring (case insensitive)
         * @param {string} [filterStartDateAfter] Optional parameter used to search for studies that have started after a specific date
         * @param {string} [filterStartDateBefore] Optional parameter used to search for studies that have start before a specific date
         * @param {string} [filterEndDate] Optional parameter used to search for studies that have a specific end date
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for studies that have been created after a specific date
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for studies that have been created before a specific date
         * @param {string} [filterAccountId] Optional parameter used to query studies by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudies: (sort, filterLifeCycleStage, filterIsExample, filterLabel, filterNameContains, filterStartDateAfter, filterStartDateBefore, filterEndDate, filterCreatedAtAfter, filterCreatedAtBefore, filterAccountId, pageSize, pageAfter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/studies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (filterLifeCycleStage !== undefined) {
                localVarQueryParameter['filter[life_cycle_stage]'] = filterLifeCycleStage;
            }
            if (filterIsExample !== undefined) {
                localVarQueryParameter['filter[is_example]'] = filterIsExample;
            }
            if (filterLabel !== undefined) {
                localVarQueryParameter['filter[label]'] = filterLabel;
            }
            if (filterNameContains !== undefined) {
                localVarQueryParameter['filter[name][contains]'] = filterNameContains;
            }
            if (filterStartDateAfter !== undefined) {
                localVarQueryParameter['filter[start_date][after]'] = (filterStartDateAfter instanceof Date) ?
                    filterStartDateAfter.toISOString() :
                    filterStartDateAfter;
            }
            if (filterStartDateBefore !== undefined) {
                localVarQueryParameter['filter[start_date][before]'] = (filterStartDateBefore instanceof Date) ?
                    filterStartDateBefore.toISOString() :
                    filterStartDateBefore;
            }
            if (filterEndDate !== undefined) {
                localVarQueryParameter['filter[end_date]'] = (filterEndDate instanceof Date) ?
                    filterEndDate.toISOString() :
                    filterEndDate;
            }
            if (filterCreatedAtAfter !== undefined) {
                localVarQueryParameter['filter[created_at][after]'] = (filterCreatedAtAfter instanceof Date) ?
                    filterCreatedAtAfter.toISOString() :
                    filterCreatedAtAfter;
            }
            if (filterCreatedAtBefore !== undefined) {
                localVarQueryParameter['filter[created_at][before]'] = (filterCreatedAtBefore instanceof Date) ?
                    filterCreatedAtBefore.toISOString() :
                    filterCreatedAtBefore;
            }
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Query the audience statistics for a study, enabling the user to see the representation of matched household characteristics to impressions and clicks. These statistics can be compared to the Average Internet Population (globally or for a specific country), or to the audience stats of other studies.
         * @summary Audience statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyAudienceStats: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('queryStudyAudienceStats', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/stats/audiences`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Query the country statistics for a study, enabling the user to see where the study is being delivered.
         * @summary Country statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyCountryStats: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('queryStudyCountryStats', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/stats/countries`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Query the device statistics for a study.
         * @summary Device statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyDeviceStats: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('queryStudyDeviceStats', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/stats/devices`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Query the frequency statistics for a study. Frequency statistics are helpful to identify the frequency of events per user, or distinct reach of a study. It can also be helpful to identify how multiple events for the same users may or may not generate more clicks.
         * @summary Frequency statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyFrequencyStats: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('queryStudyFrequencyStats', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/stats/frequencies`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Query the OLAP data for a study
         * @param {string} studyId
         * @param {StudyOlapQuery} studyOlapQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyOlapData: (studyId, studyOlapQuery, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('queryStudyOlapData', 'studyId', studyId);
            // verify required parameter 'studyOlapQuery' is not null or undefined
            assertParamExists('queryStudyOlapData', 'studyOlapQuery', studyOlapQuery);
            const localVarPath = `/studies/{study_id}/stats/olap_query`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(studyOlapQuery, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Query the timeline statistics for a study.
         * @summary Timeline statistics for study
         * @param {string} studyId
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyTimelineStats: (studyId, fromDate, toDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('queryStudyTimelineStats', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/stats/timeline`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (fromDate !== undefined) {
                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                    fromDate.toISOString().substring(0, 10) :
                    fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['to_date'] = (toDate instanceof Date) ?
                    toDate.toISOString().substring(0, 10) :
                    toDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Query the timing statistics for a study, enabling the user to see performance and delivery figures at different times of day, days of the week and days of the month.
         * @summary Timing statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyTimingStats: (studyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('queryStudyTimingStats', 'studyId', studyId);
            const localVarPath = `/studies/{study_id}/stats/timing`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates properties of a study
         * @summary Update study
         * @param {string} studyId
         * @param {StudyMutation} studyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStudyById: (studyId, studyMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('updateStudyById', 'studyId', studyId);
            // verify required parameter 'studyMutation' is not null or undefined
            assertParamExists('updateStudyById', 'studyMutation', studyMutation);
            const localVarPath = `/studies/{study_id}`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(studyMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upload a banner image for a study
         * @summary Upload study banner image
         * @param {string} studyId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStudyBannerImage: (studyId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('uploadStudyBannerImage', 'studyId', studyId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('uploadStudyBannerImage', 'body', body);
            const localVarPath = `/studies/{study_id}/assets/banner_image`
                .replace(`{${"study_id"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'image/gif';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StudiesApi - functional programming interface
 * @export
 */
export const StudiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = StudiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create shared report
         * @param {string} studyId
         * @param {SharedReportCreation} sharedReportCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSharedReport(studyId, sharedReportCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSharedReport(studyId, sharedReportCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.createSharedReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a new study
         * @summary Create study
         * @param {StudyCreation} studyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudy(studyCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStudy(studyCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.createStudy']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create an event (such as an impression or click) and ingest it into the study.
         * @summary Create study event
         * @param {string} studyId
         * @param {StudyEventCreation} studyEventCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudyEvent(studyId, studyEventCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStudyEvent(studyId, studyEventCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.createStudyEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete shared report
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSharedReportById(studyId, reportId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSharedReportById(studyId, reportId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.deleteSharedReportById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes the banner image for a study
         * @summary Delete study banner image logo
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStudyBannerImage(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteStudyBannerImage(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.deleteStudyBannerImage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes a study
         * @summary Delete study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStudyById(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteStudyById(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.deleteStudyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportAsset(studyId, reportId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSharedReportAsset(studyId, reportId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.getSharedReportAsset']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get shared report
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportById(studyId, reportId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSharedReportById(studyId, reportId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.getSharedReportById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets the study banner image, if the image is hosted on the Digiseg platform. Refer to the study\'s `banner_image_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get study banner image
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyBannerImage(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStudyBannerImage(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.getStudyBannerImage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get study information for a specific study
         * @summary Get study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyById(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStudyById(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.getStudyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get shared reports for a study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharedReportsByStudyId(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSharedReportsByStudyId(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.listSharedReportsByStudyId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List studies that the user has access to
         * @summary List studies
         * @param {ListStudiesSortEnum} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {StudyLifecycleStage} [filterLifeCycleStage] Optional parameter used to filter studies by their life cycle stage
         * @param {boolean} [filterIsExample] Optional parameter used to filter for example studies
         * @param {string} [filterLabel] Optional parameter used to filter by study label
         * @param {string} [filterNameContains] Optional parameter used to search for studies where the name contains a substring (case insensitive)
         * @param {string} [filterStartDateAfter] Optional parameter used to search for studies that have started after a specific date
         * @param {string} [filterStartDateBefore] Optional parameter used to search for studies that have start before a specific date
         * @param {string} [filterEndDate] Optional parameter used to search for studies that have a specific end date
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for studies that have been created after a specific date
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for studies that have been created before a specific date
         * @param {string} [filterAccountId] Optional parameter used to query studies by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudies(sort, filterLifeCycleStage, filterIsExample, filterLabel, filterNameContains, filterStartDateAfter, filterStartDateBefore, filterEndDate, filterCreatedAtAfter, filterCreatedAtBefore, filterAccountId, pageSize, pageAfter, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listStudies(sort, filterLifeCycleStage, filterIsExample, filterLabel, filterNameContains, filterStartDateAfter, filterStartDateBefore, filterEndDate, filterCreatedAtAfter, filterCreatedAtBefore, filterAccountId, pageSize, pageAfter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.listStudies']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Query the audience statistics for a study, enabling the user to see the representation of matched household characteristics to impressions and clicks. These statistics can be compared to the Average Internet Population (globally or for a specific country), or to the audience stats of other studies.
         * @summary Audience statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyAudienceStats(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryStudyAudienceStats(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.queryStudyAudienceStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Query the country statistics for a study, enabling the user to see where the study is being delivered.
         * @summary Country statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyCountryStats(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryStudyCountryStats(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.queryStudyCountryStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Query the device statistics for a study.
         * @summary Device statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyDeviceStats(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryStudyDeviceStats(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.queryStudyDeviceStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Query the frequency statistics for a study. Frequency statistics are helpful to identify the frequency of events per user, or distinct reach of a study. It can also be helpful to identify how multiple events for the same users may or may not generate more clicks.
         * @summary Frequency statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyFrequencyStats(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryStudyFrequencyStats(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.queryStudyFrequencyStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Query the OLAP data for a study
         * @param {string} studyId
         * @param {StudyOlapQuery} studyOlapQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyOlapData(studyId, studyOlapQuery, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryStudyOlapData(studyId, studyOlapQuery, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.queryStudyOlapData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Query the timeline statistics for a study.
         * @summary Timeline statistics for study
         * @param {string} studyId
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyTimelineStats(studyId, fromDate, toDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryStudyTimelineStats(studyId, fromDate, toDate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.queryStudyTimelineStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Query the timing statistics for a study, enabling the user to see performance and delivery figures at different times of day, days of the week and days of the month.
         * @summary Timing statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyTimingStats(studyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryStudyTimingStats(studyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.queryStudyTimingStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Updates properties of a study
         * @summary Update study
         * @param {string} studyId
         * @param {StudyMutation} studyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStudyById(studyId, studyMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateStudyById(studyId, studyMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.updateStudyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Upload a banner image for a study
         * @summary Upload study banner image
         * @param {string} studyId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStudyBannerImage(studyId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadStudyBannerImage(studyId, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StudiesApi.uploadStudyBannerImage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * StudiesApi - factory interface
 * @export
 */
export const StudiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StudiesApiFp(configuration);
    return {
        /**
         *
         * @summary Create shared report
         * @param {string} studyId
         * @param {SharedReportCreation} sharedReportCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSharedReport(studyId, sharedReportCreation, options) {
            return localVarFp.createSharedReport(studyId, sharedReportCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new study
         * @summary Create study
         * @param {StudyCreation} studyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudy(studyCreation, options) {
            return localVarFp.createStudy(studyCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an event (such as an impression or click) and ingest it into the study.
         * @summary Create study event
         * @param {string} studyId
         * @param {StudyEventCreation} studyEventCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudyEvent(studyId, studyEventCreation, options) {
            return localVarFp.createStudyEvent(studyId, studyEventCreation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete shared report
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSharedReportById(studyId, reportId, options) {
            return localVarFp.deleteSharedReportById(studyId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the banner image for a study
         * @summary Delete study banner image logo
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStudyBannerImage(studyId, options) {
            return localVarFp.deleteStudyBannerImage(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a study
         * @summary Delete study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStudyById(studyId, options) {
            return localVarFp.deleteStudyById(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportAsset(studyId, reportId, options) {
            return localVarFp.getSharedReportAsset(studyId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get shared report
         * @param {string} studyId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedReportById(studyId, reportId, options) {
            return localVarFp.getSharedReportById(studyId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the study banner image, if the image is hosted on the Digiseg platform. Refer to the study\'s `banner_image_url` to get a non-authenticated and shareable URL for the logo.
         * @summary Get study banner image
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyBannerImage(studyId, options) {
            return localVarFp.getStudyBannerImage(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get study information for a specific study
         * @summary Get study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyById(studyId, options) {
            return localVarFp.getStudyById(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get shared reports for a study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharedReportsByStudyId(studyId, options) {
            return localVarFp.listSharedReportsByStudyId(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * List studies that the user has access to
         * @summary List studies
         * @param {ListStudiesSortEnum} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {StudyLifecycleStage} [filterLifeCycleStage] Optional parameter used to filter studies by their life cycle stage
         * @param {boolean} [filterIsExample] Optional parameter used to filter for example studies
         * @param {string} [filterLabel] Optional parameter used to filter by study label
         * @param {string} [filterNameContains] Optional parameter used to search for studies where the name contains a substring (case insensitive)
         * @param {string} [filterStartDateAfter] Optional parameter used to search for studies that have started after a specific date
         * @param {string} [filterStartDateBefore] Optional parameter used to search for studies that have start before a specific date
         * @param {string} [filterEndDate] Optional parameter used to search for studies that have a specific end date
         * @param {string} [filterCreatedAtAfter] Optional parameter used to search for studies that have been created after a specific date
         * @param {string} [filterCreatedAtBefore] Optional parameter used to search for studies that have been created before a specific date
         * @param {string} [filterAccountId] Optional parameter used to query studies by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudies(sort, filterLifeCycleStage, filterIsExample, filterLabel, filterNameContains, filterStartDateAfter, filterStartDateBefore, filterEndDate, filterCreatedAtAfter, filterCreatedAtBefore, filterAccountId, pageSize, pageAfter, options) {
            return localVarFp.listStudies(sort, filterLifeCycleStage, filterIsExample, filterLabel, filterNameContains, filterStartDateAfter, filterStartDateBefore, filterEndDate, filterCreatedAtAfter, filterCreatedAtBefore, filterAccountId, pageSize, pageAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * Query the audience statistics for a study, enabling the user to see the representation of matched household characteristics to impressions and clicks. These statistics can be compared to the Average Internet Population (globally or for a specific country), or to the audience stats of other studies.
         * @summary Audience statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyAudienceStats(studyId, options) {
            return localVarFp.queryStudyAudienceStats(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Query the country statistics for a study, enabling the user to see where the study is being delivered.
         * @summary Country statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyCountryStats(studyId, options) {
            return localVarFp.queryStudyCountryStats(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Query the device statistics for a study.
         * @summary Device statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyDeviceStats(studyId, options) {
            return localVarFp.queryStudyDeviceStats(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Query the frequency statistics for a study. Frequency statistics are helpful to identify the frequency of events per user, or distinct reach of a study. It can also be helpful to identify how multiple events for the same users may or may not generate more clicks.
         * @summary Frequency statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyFrequencyStats(studyId, options) {
            return localVarFp.queryStudyFrequencyStats(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Query the OLAP data for a study
         * @param {string} studyId
         * @param {StudyOlapQuery} studyOlapQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyOlapData(studyId, studyOlapQuery, options) {
            return localVarFp.queryStudyOlapData(studyId, studyOlapQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * Query the timeline statistics for a study.
         * @summary Timeline statistics for study
         * @param {string} studyId
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyTimelineStats(studyId, fromDate, toDate, options) {
            return localVarFp.queryStudyTimelineStats(studyId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Query the timing statistics for a study, enabling the user to see performance and delivery figures at different times of day, days of the week and days of the month.
         * @summary Timing statistics for study
         * @param {string} studyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryStudyTimingStats(studyId, options) {
            return localVarFp.queryStudyTimingStats(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates properties of a study
         * @summary Update study
         * @param {string} studyId
         * @param {StudyMutation} studyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStudyById(studyId, studyMutation, options) {
            return localVarFp.updateStudyById(studyId, studyMutation, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a banner image for a study
         * @summary Upload study banner image
         * @param {string} studyId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStudyBannerImage(studyId, body, options) {
            return localVarFp.uploadStudyBannerImage(studyId, body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StudiesApi - object-oriented interface
 * @export
 * @class StudiesApi
 * @extends {BaseAPI}
 */
export class StudiesApi extends BaseAPI {
    /**
     *
     * @summary Create shared report
     * @param {string} studyId
     * @param {SharedReportCreation} sharedReportCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    createSharedReport(studyId, sharedReportCreation, options) {
        return StudiesApiFp(this.configuration).createSharedReport(studyId, sharedReportCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new study
     * @summary Create study
     * @param {StudyCreation} studyCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    createStudy(studyCreation, options) {
        return StudiesApiFp(this.configuration).createStudy(studyCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create an event (such as an impression or click) and ingest it into the study.
     * @summary Create study event
     * @param {string} studyId
     * @param {StudyEventCreation} studyEventCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    createStudyEvent(studyId, studyEventCreation, options) {
        return StudiesApiFp(this.configuration).createStudyEvent(studyId, studyEventCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete shared report
     * @param {string} studyId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    deleteSharedReportById(studyId, reportId, options) {
        return StudiesApiFp(this.configuration).deleteSharedReportById(studyId, reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the banner image for a study
     * @summary Delete study banner image logo
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    deleteStudyBannerImage(studyId, options) {
        return StudiesApiFp(this.configuration).deleteStudyBannerImage(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a study
     * @summary Delete study
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    deleteStudyById(studyId, options) {
        return StudiesApiFp(this.configuration).deleteStudyById(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} studyId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    getSharedReportAsset(studyId, reportId, options) {
        return StudiesApiFp(this.configuration).getSharedReportAsset(studyId, reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get shared report
     * @param {string} studyId
     * @param {string} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    getSharedReportById(studyId, reportId, options) {
        return StudiesApiFp(this.configuration).getSharedReportById(studyId, reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the study banner image, if the image is hosted on the Digiseg platform. Refer to the study\'s `banner_image_url` to get a non-authenticated and shareable URL for the logo.
     * @summary Get study banner image
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    getStudyBannerImage(studyId, options) {
        return StudiesApiFp(this.configuration).getStudyBannerImage(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get study information for a specific study
     * @summary Get study
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    getStudyById(studyId, options) {
        return StudiesApiFp(this.configuration).getStudyById(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get shared reports for a study
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    listSharedReportsByStudyId(studyId, options) {
        return StudiesApiFp(this.configuration).listSharedReportsByStudyId(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List studies that the user has access to
     * @summary List studies
     * @param {ListStudiesSortEnum} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
     * @param {StudyLifecycleStage} [filterLifeCycleStage] Optional parameter used to filter studies by their life cycle stage
     * @param {boolean} [filterIsExample] Optional parameter used to filter for example studies
     * @param {string} [filterLabel] Optional parameter used to filter by study label
     * @param {string} [filterNameContains] Optional parameter used to search for studies where the name contains a substring (case insensitive)
     * @param {string} [filterStartDateAfter] Optional parameter used to search for studies that have started after a specific date
     * @param {string} [filterStartDateBefore] Optional parameter used to search for studies that have start before a specific date
     * @param {string} [filterEndDate] Optional parameter used to search for studies that have a specific end date
     * @param {string} [filterCreatedAtAfter] Optional parameter used to search for studies that have been created after a specific date
     * @param {string} [filterCreatedAtBefore] Optional parameter used to search for studies that have been created before a specific date
     * @param {string} [filterAccountId] Optional parameter used to query studies by specific account IDs (only available to super admins). The value &#x60;*&#x60; is synonymous for \&quot;all accounts\&quot;.
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    listStudies(sort, filterLifeCycleStage, filterIsExample, filterLabel, filterNameContains, filterStartDateAfter, filterStartDateBefore, filterEndDate, filterCreatedAtAfter, filterCreatedAtBefore, filterAccountId, pageSize, pageAfter, options) {
        return StudiesApiFp(this.configuration).listStudies(sort, filterLifeCycleStage, filterIsExample, filterLabel, filterNameContains, filterStartDateAfter, filterStartDateBefore, filterEndDate, filterCreatedAtAfter, filterCreatedAtBefore, filterAccountId, pageSize, pageAfter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Query the audience statistics for a study, enabling the user to see the representation of matched household characteristics to impressions and clicks. These statistics can be compared to the Average Internet Population (globally or for a specific country), or to the audience stats of other studies.
     * @summary Audience statistics for study
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    queryStudyAudienceStats(studyId, options) {
        return StudiesApiFp(this.configuration).queryStudyAudienceStats(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Query the country statistics for a study, enabling the user to see where the study is being delivered.
     * @summary Country statistics for study
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    queryStudyCountryStats(studyId, options) {
        return StudiesApiFp(this.configuration).queryStudyCountryStats(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Query the device statistics for a study.
     * @summary Device statistics for study
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    queryStudyDeviceStats(studyId, options) {
        return StudiesApiFp(this.configuration).queryStudyDeviceStats(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Query the frequency statistics for a study. Frequency statistics are helpful to identify the frequency of events per user, or distinct reach of a study. It can also be helpful to identify how multiple events for the same users may or may not generate more clicks.
     * @summary Frequency statistics for study
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    queryStudyFrequencyStats(studyId, options) {
        return StudiesApiFp(this.configuration).queryStudyFrequencyStats(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Query the OLAP data for a study
     * @param {string} studyId
     * @param {StudyOlapQuery} studyOlapQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    queryStudyOlapData(studyId, studyOlapQuery, options) {
        return StudiesApiFp(this.configuration).queryStudyOlapData(studyId, studyOlapQuery, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Query the timeline statistics for a study.
     * @summary Timeline statistics for study
     * @param {string} studyId
     * @param {string} [fromDate]
     * @param {string} [toDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    queryStudyTimelineStats(studyId, fromDate, toDate, options) {
        return StudiesApiFp(this.configuration).queryStudyTimelineStats(studyId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Query the timing statistics for a study, enabling the user to see performance and delivery figures at different times of day, days of the week and days of the month.
     * @summary Timing statistics for study
     * @param {string} studyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    queryStudyTimingStats(studyId, options) {
        return StudiesApiFp(this.configuration).queryStudyTimingStats(studyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates properties of a study
     * @summary Update study
     * @param {string} studyId
     * @param {StudyMutation} studyMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    updateStudyById(studyId, studyMutation, options) {
        return StudiesApiFp(this.configuration).updateStudyById(studyId, studyMutation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload a banner image for a study
     * @summary Upload study banner image
     * @param {string} studyId
     * @param {File} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudiesApi
     */
    uploadStudyBannerImage(studyId, body, options) {
        return StudiesApiFp(this.configuration).uploadStudyBannerImage(studyId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const ListStudiesSortEnum = {
    CreatedAt: 'created_at',
    CreatedAt2: '-created_at',
    Name: 'name',
    Name2: '-name'
};
/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Accept subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSubscriptionOffer: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('acceptSubscriptionOffer', 'offerId', offerId);
            const localVarPath = `/subscription_offers/{offer_id}/accept`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription: (accountId, accountSubscriptionCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createAccountSubscription', 'accountId', accountId);
            // verify required parameter 'accountSubscriptionCreation' is not null or undefined
            assertParamExists('createAccountSubscription', 'accountSubscriptionCreation', accountSubscriptionCreation);
            const localVarPath = `/accounts/{account_id}/subscriptions`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accountSubscriptionCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Initiate a checkout session to purchase a subscription using Stripe
         * @param {string} accountId
         * @param {StripeAccountSubscriptionPurchaseCreation} stripeAccountSubscriptionPurchaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeAccountSubscriptionPurchase: (accountId, stripeAccountSubscriptionPurchaseCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createStripeAccountSubscriptionPurchase', 'accountId', accountId);
            // verify required parameter 'stripeAccountSubscriptionPurchaseCreation' is not null or undefined
            assertParamExists('createStripeAccountSubscriptionPurchase', 'stripeAccountSubscriptionPurchaseCreation', stripeAccountSubscriptionPurchaseCreation);
            const localVarPath = `/accounts/{account_id}/subscriptions/purchase/stripe`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stripeAccountSubscriptionPurchaseCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a subscription offer. Only permitted for super-admins.
         * @summary Create subscription offer
         * @param {SubscriptionOfferCreation} subscriptionOfferCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionOffer: (subscriptionOfferCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionOfferCreation' is not null or undefined
            assertParamExists('createSubscriptionOffer', 'subscriptionOfferCreation', subscriptionOfferCreation);
            const localVarPath = `/subscription_offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionOfferCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a subscription plan. Only permitted for super-admins.
         * @summary Create subscription plan
         * @param {SubscriptionPlanFull} subscriptionPlanFull
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionPlan: (subscriptionPlanFull, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionPlanFull' is not null or undefined
            assertParamExists('createSubscriptionPlan', 'subscriptionPlanFull', subscriptionPlanFull);
            const localVarPath = `/subscription_plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionPlanFull, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById: (accountId, subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccountSubscriptionById', 'accountId', accountId);
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('deleteAccountSubscriptionById', 'subscriptionId', subscriptionId);
            const localVarPath = `/accounts/{account_id}/subscriptions/{subscription_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionOfferById: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('deleteSubscriptionOfferById', 'offerId', offerId);
            const localVarPath = `/subscription_offers/{offer_id}`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a specific subscription for an account
         * @summary Get account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptionById: (accountId, subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountSubscriptionById', 'accountId', accountId);
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getAccountSubscriptionById', 'subscriptionId', subscriptionId);
            const localVarPath = `/accounts/{account_id}/subscriptions/{subscription_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a summary of subscriptions for an account
         * @summary Get account subscriptions summary
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptions: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountSubscriptions', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/subscriptions`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionOfferById: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('getSubscriptionOfferById', 'offerId', offerId);
            const localVarPath = `/subscription_offers/{offer_id}`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets a specific subscription plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPlanById: (planId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('getSubscriptionPlanById', 'planId', planId);
            const localVarPath = `/subscription_plans/{plan_id}`
                .replace(`{${"plan_id"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List subscription offers
         * @param {string} [filterAccountId] Optional parameter used to filter on the account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionOffers: (filterAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/subscription_offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List subscription plans
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {boolean} [filterIsPublic] Optional parameter used to filter on the &#x60;is_public&#x60; field
         * @param {SubscriptionProductType} [filterProductType] Optional parameter used to filter on the &#x60;product_type&#x60; field
         * @param {SubscriptionPriceCurrency} [filterListPriceCurrency] Optional parameter used to filter on the list price\&#39;s currency
         * @param {SubscriptionPriceInterval} [filterListPriceInterval] Optional parameter used to filter on the list price\&#39;s interval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionPlans: (pageSize, pageAfter, filterIsPublic, filterProductType, filterListPriceCurrency, filterListPriceInterval, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/subscription_plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            if (filterIsPublic !== undefined) {
                localVarQueryParameter['filter[is_public]'] = filterIsPublic;
            }
            if (filterProductType !== undefined) {
                localVarQueryParameter['filter[product_type]'] = filterProductType;
            }
            if (filterListPriceCurrency !== undefined) {
                localVarQueryParameter['filter[list_price.currency]'] = filterListPriceCurrency;
            }
            if (filterListPriceInterval !== undefined) {
                localVarQueryParameter['filter[list_price.interval]'] = filterListPriceInterval;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync subscription plan information with Stripe
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncSubscriptionPlan: (planId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('stripeSyncSubscriptionPlan', 'planId', planId);
            const localVarPath = `/subscription_plans/{plan_id}/sync/stripe`
                .replace(`{${"plan_id"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update subscription plan
         * @param {string} planId
         * @param {SubscriptionPlanMutation} subscriptionPlanMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPlanById: (planId, subscriptionPlanMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('updateSubscriptionPlanById', 'planId', planId);
            // verify required parameter 'subscriptionPlanMutation' is not null or undefined
            assertParamExists('updateSubscriptionPlanById', 'subscriptionPlanMutation', subscriptionPlanMutation);
            const localVarPath = `/subscription_plans/{plan_id}`
                .replace(`{${"plan_id"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionPlanMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
export const SubscriptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Accept subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSubscriptionOffer(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.acceptSubscriptionOffer(offerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.acceptSubscriptionOffer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription(accountId, accountSubscriptionCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccountSubscription(accountId, accountSubscriptionCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.createAccountSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Initiate a checkout session to purchase a subscription using Stripe
         * @param {string} accountId
         * @param {StripeAccountSubscriptionPurchaseCreation} stripeAccountSubscriptionPurchaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.createStripeAccountSubscriptionPurchase']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a subscription offer. Only permitted for super-admins.
         * @summary Create subscription offer
         * @param {SubscriptionOfferCreation} subscriptionOfferCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionOffer(subscriptionOfferCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSubscriptionOffer(subscriptionOfferCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.createSubscriptionOffer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a subscription plan. Only permitted for super-admins.
         * @summary Create subscription plan
         * @param {SubscriptionPlanFull} subscriptionPlanFull
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionPlan(subscriptionPlanFull, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSubscriptionPlan(subscriptionPlanFull, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.createSubscriptionPlan']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById(accountId, subscriptionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccountSubscriptionById(accountId, subscriptionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.deleteAccountSubscriptionById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionOfferById(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSubscriptionOfferById(offerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.deleteSubscriptionOfferById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets a specific subscription for an account
         * @summary Get account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptionById(accountId, subscriptionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountSubscriptionById(accountId, subscriptionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.getAccountSubscriptionById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a summary of subscriptions for an account
         * @summary Get account subscriptions summary
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptions(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountSubscriptions(accountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.getAccountSubscriptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionOfferById(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionOfferById(offerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.getSubscriptionOfferById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Gets a specific subscription plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPlanById(planId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionPlanById(planId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.getSubscriptionPlanById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List subscription offers
         * @param {string} [filterAccountId] Optional parameter used to filter on the account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionOffers(filterAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSubscriptionOffers(filterAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.listSubscriptionOffers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List subscription plans
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {boolean} [filterIsPublic] Optional parameter used to filter on the &#x60;is_public&#x60; field
         * @param {SubscriptionProductType} [filterProductType] Optional parameter used to filter on the &#x60;product_type&#x60; field
         * @param {SubscriptionPriceCurrency} [filterListPriceCurrency] Optional parameter used to filter on the list price\&#39;s currency
         * @param {SubscriptionPriceInterval} [filterListPriceInterval] Optional parameter used to filter on the list price\&#39;s interval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionPlans(pageSize, pageAfter, filterIsPublic, filterProductType, filterListPriceCurrency, filterListPriceInterval, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSubscriptionPlans(pageSize, pageAfter, filterIsPublic, filterProductType, filterListPriceCurrency, filterListPriceInterval, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.listSubscriptionPlans']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sync subscription plan information with Stripe
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncSubscriptionPlan(planId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.stripeSyncSubscriptionPlan(planId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.stripeSyncSubscriptionPlan']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update subscription plan
         * @param {string} planId
         * @param {SubscriptionPlanMutation} subscriptionPlanMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPlanById(planId, subscriptionPlanMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSubscriptionPlanById(planId, subscriptionPlanMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubscriptionsApi.updateSubscriptionPlanById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * SubscriptionsApi - factory interface
 * @export
 */
export const SubscriptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SubscriptionsApiFp(configuration);
    return {
        /**
         *
         * @summary Accept subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSubscriptionOffer(offerId, options) {
            return localVarFp.acceptSubscriptionOffer(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a subscription on an account. Only permitted for super-admins.
         * @summary Create account subscription
         * @param {string} accountId
         * @param {AccountSubscriptionCreation} accountSubscriptionCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSubscription(accountId, accountSubscriptionCreation, options) {
            return localVarFp.createAccountSubscription(accountId, accountSubscriptionCreation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Initiate a checkout session to purchase a subscription using Stripe
         * @param {string} accountId
         * @param {StripeAccountSubscriptionPurchaseCreation} stripeAccountSubscriptionPurchaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options) {
            return localVarFp.createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a subscription offer. Only permitted for super-admins.
         * @summary Create subscription offer
         * @param {SubscriptionOfferCreation} subscriptionOfferCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionOffer(subscriptionOfferCreation, options) {
            return localVarFp.createSubscriptionOffer(subscriptionOfferCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a subscription plan. Only permitted for super-admins.
         * @summary Create subscription plan
         * @param {SubscriptionPlanFull} subscriptionPlanFull
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionPlan(subscriptionPlanFull, options) {
            return localVarFp.createSubscriptionPlan(subscriptionPlanFull, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a subscription on an account. Only permitted for super-admins.
         * @summary Delete account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSubscriptionById(accountId, subscriptionId, options) {
            return localVarFp.deleteAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionOfferById(offerId, options) {
            return localVarFp.deleteSubscriptionOfferById(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a specific subscription for an account
         * @summary Get account subscription
         * @param {string} accountId
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptionById(accountId, subscriptionId, options) {
            return localVarFp.getAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a summary of subscriptions for an account
         * @summary Get account subscriptions summary
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSubscriptions(accountId, options) {
            return localVarFp.getAccountSubscriptions(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get subscription offer
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionOfferById(offerId, options) {
            return localVarFp.getSubscriptionOfferById(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a specific subscription plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPlanById(planId, options) {
            return localVarFp.getSubscriptionPlanById(planId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List subscription offers
         * @param {string} [filterAccountId] Optional parameter used to filter on the account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionOffers(filterAccountId, options) {
            return localVarFp.listSubscriptionOffers(filterAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List subscription plans
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {boolean} [filterIsPublic] Optional parameter used to filter on the &#x60;is_public&#x60; field
         * @param {SubscriptionProductType} [filterProductType] Optional parameter used to filter on the &#x60;product_type&#x60; field
         * @param {SubscriptionPriceCurrency} [filterListPriceCurrency] Optional parameter used to filter on the list price\&#39;s currency
         * @param {SubscriptionPriceInterval} [filterListPriceInterval] Optional parameter used to filter on the list price\&#39;s interval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionPlans(pageSize, pageAfter, filterIsPublic, filterProductType, filterListPriceCurrency, filterListPriceInterval, options) {
            return localVarFp.listSubscriptionPlans(pageSize, pageAfter, filterIsPublic, filterProductType, filterListPriceCurrency, filterListPriceInterval, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync subscription plan information with Stripe
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSyncSubscriptionPlan(planId, options) {
            return localVarFp.stripeSyncSubscriptionPlan(planId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update subscription plan
         * @param {string} planId
         * @param {SubscriptionPlanMutation} subscriptionPlanMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPlanById(planId, subscriptionPlanMutation, options) {
            return localVarFp.updateSubscriptionPlanById(planId, subscriptionPlanMutation, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
export class SubscriptionsApi extends BaseAPI {
    /**
     *
     * @summary Accept subscription offer
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    acceptSubscriptionOffer(offerId, options) {
        return SubscriptionsApiFp(this.configuration).acceptSubscriptionOffer(offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a subscription on an account. Only permitted for super-admins.
     * @summary Create account subscription
     * @param {string} accountId
     * @param {AccountSubscriptionCreation} accountSubscriptionCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    createAccountSubscription(accountId, accountSubscriptionCreation, options) {
        return SubscriptionsApiFp(this.configuration).createAccountSubscription(accountId, accountSubscriptionCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Initiate a checkout session to purchase a subscription using Stripe
     * @param {string} accountId
     * @param {StripeAccountSubscriptionPurchaseCreation} stripeAccountSubscriptionPurchaseCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options) {
        return SubscriptionsApiFp(this.configuration).createStripeAccountSubscriptionPurchase(accountId, stripeAccountSubscriptionPurchaseCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a subscription offer. Only permitted for super-admins.
     * @summary Create subscription offer
     * @param {SubscriptionOfferCreation} subscriptionOfferCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    createSubscriptionOffer(subscriptionOfferCreation, options) {
        return SubscriptionsApiFp(this.configuration).createSubscriptionOffer(subscriptionOfferCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a subscription plan. Only permitted for super-admins.
     * @summary Create subscription plan
     * @param {SubscriptionPlanFull} subscriptionPlanFull
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    createSubscriptionPlan(subscriptionPlanFull, options) {
        return SubscriptionsApiFp(this.configuration).createSubscriptionPlan(subscriptionPlanFull, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a subscription on an account. Only permitted for super-admins.
     * @summary Delete account subscription
     * @param {string} accountId
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    deleteAccountSubscriptionById(accountId, subscriptionId, options) {
        return SubscriptionsApiFp(this.configuration).deleteAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete subscription offer
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    deleteSubscriptionOfferById(offerId, options) {
        return SubscriptionsApiFp(this.configuration).deleteSubscriptionOfferById(offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a specific subscription for an account
     * @summary Get account subscription
     * @param {string} accountId
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    getAccountSubscriptionById(accountId, subscriptionId, options) {
        return SubscriptionsApiFp(this.configuration).getAccountSubscriptionById(accountId, subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a summary of subscriptions for an account
     * @summary Get account subscriptions summary
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    getAccountSubscriptions(accountId, options) {
        return SubscriptionsApiFp(this.configuration).getAccountSubscriptions(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get subscription offer
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    getSubscriptionOfferById(offerId, options) {
        return SubscriptionsApiFp(this.configuration).getSubscriptionOfferById(offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a specific subscription plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    getSubscriptionPlanById(planId, options) {
        return SubscriptionsApiFp(this.configuration).getSubscriptionPlanById(planId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List subscription offers
     * @param {string} [filterAccountId] Optional parameter used to filter on the account ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    listSubscriptionOffers(filterAccountId, options) {
        return SubscriptionsApiFp(this.configuration).listSubscriptionOffers(filterAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List subscription plans
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {boolean} [filterIsPublic] Optional parameter used to filter on the &#x60;is_public&#x60; field
     * @param {SubscriptionProductType} [filterProductType] Optional parameter used to filter on the &#x60;product_type&#x60; field
     * @param {SubscriptionPriceCurrency} [filterListPriceCurrency] Optional parameter used to filter on the list price\&#39;s currency
     * @param {SubscriptionPriceInterval} [filterListPriceInterval] Optional parameter used to filter on the list price\&#39;s interval
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    listSubscriptionPlans(pageSize, pageAfter, filterIsPublic, filterProductType, filterListPriceCurrency, filterListPriceInterval, options) {
        return SubscriptionsApiFp(this.configuration).listSubscriptionPlans(pageSize, pageAfter, filterIsPublic, filterProductType, filterListPriceCurrency, filterListPriceInterval, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync subscription plan information with Stripe
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    stripeSyncSubscriptionPlan(planId, options) {
        return SubscriptionsApiFp(this.configuration).stripeSyncSubscriptionPlan(planId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update subscription plan
     * @param {string} planId
     * @param {SubscriptionPlanMutation} subscriptionPlanMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    updateSubscriptionPlanById(planId, subscriptionPlanMutation, options) {
        return SubscriptionsApiFp(this.configuration).updateSubscriptionPlanById(planId, subscriptionPlanMutation, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TaxonomyApi - axios parameter creator
 * @export
 */
export const TaxonomyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Complete/respond to an audience recommendation
         * @param {AudienceRecommendationRequestMessage} audienceRecommendationRequestMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAudienceRecommendation: (audienceRecommendationRequestMessage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'audienceRecommendationRequestMessage' is not null or undefined
            assertParamExists('completeAudienceRecommendation', 'audienceRecommendationRequestMessage', audienceRecommendationRequestMessage);
            const localVarPath = `/taxonomy/audiences/recommendation/completion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(audienceRecommendationRequestMessage, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List audience platforms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudiencePlatforms: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/taxonomy/audience_platforms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List audiences
         * @param {string} [platform] A platform code to apply for platform-specific audience codes
         * @param {string} [country] A country code to apply for platform-specific and country-specific audience codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudiences: (platform, country, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/taxonomy/audiences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/taxonomy/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TaxonomyApi - functional programming interface
 * @export
 */
export const TaxonomyApiFp = function (configuration) {
    const localVarAxiosParamCreator = TaxonomyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Complete/respond to an audience recommendation
         * @param {AudienceRecommendationRequestMessage} audienceRecommendationRequestMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAudienceRecommendation(audienceRecommendationRequestMessage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeAudienceRecommendation(audienceRecommendationRequestMessage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TaxonomyApi.completeAudienceRecommendation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List audience platforms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudiencePlatforms(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAudiencePlatforms(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TaxonomyApi.listAudiencePlatforms']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List audiences
         * @param {string} [platform] A platform code to apply for platform-specific audience codes
         * @param {string} [country] A country code to apply for platform-specific and country-specific audience codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudiences(platform, country, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAudiences(platform, country, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TaxonomyApi.listAudiences']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCountries(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TaxonomyApi.listCountries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * TaxonomyApi - factory interface
 * @export
 */
export const TaxonomyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TaxonomyApiFp(configuration);
    return {
        /**
         *
         * @summary Complete/respond to an audience recommendation
         * @param {AudienceRecommendationRequestMessage} audienceRecommendationRequestMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAudienceRecommendation(audienceRecommendationRequestMessage, options) {
            return localVarFp.completeAudienceRecommendation(audienceRecommendationRequestMessage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List audience platforms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudiencePlatforms(options) {
            return localVarFp.listAudiencePlatforms(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List audiences
         * @param {string} [platform] A platform code to apply for platform-specific audience codes
         * @param {string} [country] A country code to apply for platform-specific and country-specific audience codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudiences(platform, country, options) {
            return localVarFp.listAudiences(platform, country, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries(options) {
            return localVarFp.listCountries(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaxonomyApi - object-oriented interface
 * @export
 * @class TaxonomyApi
 * @extends {BaseAPI}
 */
export class TaxonomyApi extends BaseAPI {
    /**
     *
     * @summary Complete/respond to an audience recommendation
     * @param {AudienceRecommendationRequestMessage} audienceRecommendationRequestMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    completeAudienceRecommendation(audienceRecommendationRequestMessage, options) {
        return TaxonomyApiFp(this.configuration).completeAudienceRecommendation(audienceRecommendationRequestMessage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List audience platforms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    listAudiencePlatforms(options) {
        return TaxonomyApiFp(this.configuration).listAudiencePlatforms(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List audiences
     * @param {string} [platform] A platform code to apply for platform-specific audience codes
     * @param {string} [country] A country code to apply for platform-specific and country-specific audience codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    listAudiences(platform, country, options) {
        return TaxonomyApiFp(this.configuration).listAudiences(platform, country, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxonomyApi
     */
    listCountries(options) {
        return TaxonomyApiFp(this.configuration).listCountries(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsageApi - axios parameter creator
 * @export
 */
export const UsageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Provides usage stats on a daily basis. Results available for the last 2 months.
         * @summary List daily usage of Audience Data
         * @param {string} [filterDateFrom] Date to query from
         * @param {string} [filterDateTo] Date to query to
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataDailyUsage: (filterDateFrom, filterDateTo, filterAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/usage/audience_data/daily`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterDateFrom !== undefined) {
                localVarQueryParameter['filter[date][from]'] = (filterDateFrom instanceof Date) ?
                    filterDateFrom.toISOString().substring(0, 10) :
                    filterDateFrom;
            }
            if (filterDateTo !== undefined) {
                localVarQueryParameter['filter[date][to]'] = (filterDateTo instanceof Date) ?
                    filterDateTo.toISOString().substring(0, 10) :
                    filterDateTo;
            }
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides usage stats on a monthly basis.
         * @summary List monthly usage of Audience Data
         * @param {number} [filterYear] Year to filter by
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataMonthlyUsage: (filterYear, filterAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/usage/audience_data/monthly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterYear !== undefined) {
                localVarQueryParameter['filter[year]'] = filterYear;
            }
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides usage stats on a near-realtime basis. Results available for the last 24 hours, provided with as short delay as possible. The results will be returned in usage objects, each representing 5 minutes of non-zero usage.
         * @summary List realtime usage of Audience Data
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataRealtimeUsage: (filterAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/usage/audience_data/realtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsageApi - functional programming interface
 * @export
 */
export const UsageApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsageApiAxiosParamCreator(configuration);
    return {
        /**
         * Provides usage stats on a daily basis. Results available for the last 2 months.
         * @summary List daily usage of Audience Data
         * @param {string} [filterDateFrom] Date to query from
         * @param {string} [filterDateTo] Date to query to
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataDailyUsage(filterDateFrom, filterDateTo, filterAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAudienceDataDailyUsage(filterDateFrom, filterDateTo, filterAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsageApi.listAudienceDataDailyUsage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Provides usage stats on a monthly basis.
         * @summary List monthly usage of Audience Data
         * @param {number} [filterYear] Year to filter by
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataMonthlyUsage(filterYear, filterAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAudienceDataMonthlyUsage(filterYear, filterAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsageApi.listAudienceDataMonthlyUsage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Provides usage stats on a near-realtime basis. Results available for the last 24 hours, provided with as short delay as possible. The results will be returned in usage objects, each representing 5 minutes of non-zero usage.
         * @summary List realtime usage of Audience Data
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataRealtimeUsage(filterAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAudienceDataRealtimeUsage(filterAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsageApi.listAudienceDataRealtimeUsage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * UsageApi - factory interface
 * @export
 */
export const UsageApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsageApiFp(configuration);
    return {
        /**
         * Provides usage stats on a daily basis. Results available for the last 2 months.
         * @summary List daily usage of Audience Data
         * @param {string} [filterDateFrom] Date to query from
         * @param {string} [filterDateTo] Date to query to
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataDailyUsage(filterDateFrom, filterDateTo, filterAccountId, options) {
            return localVarFp.listAudienceDataDailyUsage(filterDateFrom, filterDateTo, filterAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides usage stats on a monthly basis.
         * @summary List monthly usage of Audience Data
         * @param {number} [filterYear] Year to filter by
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataMonthlyUsage(filterYear, filterAccountId, options) {
            return localVarFp.listAudienceDataMonthlyUsage(filterYear, filterAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides usage stats on a near-realtime basis. Results available for the last 24 hours, provided with as short delay as possible. The results will be returned in usage objects, each representing 5 minutes of non-zero usage.
         * @summary List realtime usage of Audience Data
         * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudienceDataRealtimeUsage(filterAccountId, options) {
            return localVarFp.listAudienceDataRealtimeUsage(filterAccountId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsageApi - object-oriented interface
 * @export
 * @class UsageApi
 * @extends {BaseAPI}
 */
export class UsageApi extends BaseAPI {
    /**
     * Provides usage stats on a daily basis. Results available for the last 2 months.
     * @summary List daily usage of Audience Data
     * @param {string} [filterDateFrom] Date to query from
     * @param {string} [filterDateTo] Date to query to
     * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    listAudienceDataDailyUsage(filterDateFrom, filterDateTo, filterAccountId, options) {
        return UsageApiFp(this.configuration).listAudienceDataDailyUsage(filterDateFrom, filterDateTo, filterAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides usage stats on a monthly basis.
     * @summary List monthly usage of Audience Data
     * @param {number} [filterYear] Year to filter by
     * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    listAudienceDataMonthlyUsage(filterYear, filterAccountId, options) {
        return UsageApiFp(this.configuration).listAudienceDataMonthlyUsage(filterYear, filterAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides usage stats on a near-realtime basis. Results available for the last 24 hours, provided with as short delay as possible. The results will be returned in usage objects, each representing 5 minutes of non-zero usage.
     * @summary List realtime usage of Audience Data
     * @param {string} [filterAccountId] Optional parameter used to query usage of specific account IDs (only available to super admins).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    listAudienceDataRealtimeUsage(filterAccountId, options) {
        return UsageApiFp(this.configuration).listAudienceDataRealtimeUsage(filterAccountId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Adds a user to the referenced account.
         * @summary Add user to account
         * @param {string} accountId
         * @param {AccountUserAddition} accountUserAddition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToAccount: (accountId, accountUserAddition, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('addUserToAccount', 'accountId', accountId);
            // verify required parameter 'accountUserAddition' is not null or undefined
            assertParamExists('addUserToAccount', 'accountUserAddition', accountUserAddition);
            const localVarPath = `/accounts/{account_id}/users`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accountUserAddition, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create API key for the given user. When an API key is created, the `token` value will be exposed in the response. This token can be passed as the `X-API-KEY` header value for future requests. It is not obtainable in other API requests (ie. the client must decide how to keep the API key token in e.g. a vault or similar).
         * @summary Create API key
         * @param {string} userId
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey: (userId, apiKeyCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createApiKey', 'userId', userId);
            // verify required parameter 'apiKeyCreation' is not null or undefined
            assertParamExists('createApiKey', 'apiKeyCreation', apiKeyCreation);
            const localVarPath = `/users/{user_id}/apikeys`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create user
         * @param {UserCreation} userCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: (userCreation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userCreation' is not null or undefined
            assertParamExists('createUser', 'userCreation', userCreation);
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userCreation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyById: (userId, keyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteApiKeyById', 'userId', userId);
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('deleteApiKeyById', 'keyId', keyId);
            const localVarPath = `/users/{user_id}/apikeys/{key_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"key_id"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes the avatar for a user
         * @summary Delete user avatar
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAvatar: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserAvatar', 'userId', userId);
            const localVarPath = `/users/{user_id}/assets/avatar`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserById', 'userId', userId);
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyById: (userId, keyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getApiKeyById', 'userId', userId);
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('getApiKeyById', 'keyId', keyId);
            const localVarPath = `/users/{user_id}/apikeys/{key_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"key_id"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get information about the currently authenticated user
         * @summary Get current user
         * @param {Array<UserIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: (include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountMembership: (accountId, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getUserAccountMembership', 'accountId', accountId);
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserAccountMembership', 'userId', userId);
            const localVarPath = `/accounts/{account_id}/users/{user_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the user avatar, if the image is hosted on the Digiseg platform. Refer to the user\'s `avatar_url` to get a non-authenticated and shareable URL for the avatar.
         * @summary Get user avatar
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAvatar: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserAvatar', 'userId', userId);
            const localVarPath = `/users/{user_id}/assets/avatar`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get user
         * @param {string} userId
         * @param {Array<UserIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: (userId, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId);
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List API keys for user
         * @param {string} userId
         * @param {string} [filterAccountId] Filter by specific account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByUserId: (userId, filterAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listApiKeysByUserId', 'userId', userId);
            const localVarPath = `/users/{user_id}/apikeys`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List users
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. &#x60;super_admin&#x60;
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterAccountId] Filter based on the user\&#39;s account
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: (filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterPlatformRoles !== undefined) {
                localVarQueryParameter['filter[platform_roles]'] = filterPlatformRoles;
            }
            if (filterAccountRoles !== undefined) {
                localVarQueryParameter['filter[account_roles]'] = filterAccountRoles;
            }
            if (filterAccountId !== undefined) {
                localVarQueryParameter['filter[account_id]'] = filterAccountId;
            }
            if (filterNameContains !== undefined) {
                localVarQueryParameter['filter[name][contains]'] = filterNameContains;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List users for account
         * @param {string} accountId
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. super_admin
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersByAccountId: (accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listUsersByAccountId', 'accountId', accountId);
            const localVarPath = `/accounts/{account_id}/users`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            if (filterPlatformRoles !== undefined) {
                localVarQueryParameter['filter[platform_roles]'] = filterPlatformRoles;
            }
            if (filterAccountRoles !== undefined) {
                localVarQueryParameter['filter[account_roles]'] = filterAccountRoles;
            }
            if (filterNameContains !== undefined) {
                localVarQueryParameter['filter[name][contains]'] = filterNameContains;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }
            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Removes a user from the referenced account.
         * @summary Remove user from account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromAccount: (accountId, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('removeUserFromAccount', 'accountId', accountId);
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserFromAccount', 'userId', userId);
            const localVarPath = `/accounts/{account_id}/users/{user_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update API key
         * @param {string} userId
         * @param {string} keyId
         * @param {ApiKeyMutation} apiKeyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyById: (userId, keyId, apiKeyMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateApiKeyById', 'userId', userId);
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('updateApiKeyById', 'keyId', keyId);
            // verify required parameter 'apiKeyMutation' is not null or undefined
            assertParamExists('updateApiKeyById', 'apiKeyMutation', apiKeyMutation);
            const localVarPath = `/users/{user_id}/apikeys/{key_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"key_id"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {UserAccountMembershipUpdate} userAccountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountMembership: (accountId, userId, userAccountMembershipUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateUserAccountMembership', 'accountId', accountId);
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserAccountMembership', 'userId', userId);
            // verify required parameter 'userAccountMembershipUpdate' is not null or undefined
            assertParamExists('updateUserAccountMembership', 'userAccountMembershipUpdate', userAccountMembershipUpdate);
            const localVarPath = `/accounts/{account_id}/users/{user_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userAccountMembershipUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update user
         * @param {string} userId
         * @param {UserMutation} userMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserById: (userId, userMutation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserById', 'userId', userId);
            // verify required parameter 'userMutation' is not null or undefined
            assertParamExists('updateUserById', 'userMutation', userMutation);
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userMutation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upload a avatar for a user
         * @summary Upload user avatar
         * @param {string} userId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserAvatar: (userId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('uploadUserAvatar', 'userId', userId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('uploadUserAvatar', 'body', body);
            const localVarPath = `/users/{user_id}/assets/avatar`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'image/gif';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         * Adds a user to the referenced account.
         * @summary Add user to account
         * @param {string} accountId
         * @param {AccountUserAddition} accountUserAddition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToAccount(accountId, accountUserAddition, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addUserToAccount(accountId, accountUserAddition, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.addUserToAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create API key for the given user. When an API key is created, the `token` value will be exposed in the response. This token can be passed as the `X-API-KEY` header value for future requests. It is not obtainable in other API requests (ie. the client must decide how to keep the API key token in e.g. a vault or similar).
         * @summary Create API key
         * @param {string} userId
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey(userId, apiKeyCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createApiKey(userId, apiKeyCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.createApiKey']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create user
         * @param {UserCreation} userCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUser(userCreation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.createUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyById(userId, keyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteApiKeyById(userId, keyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.deleteApiKeyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes the avatar for a user
         * @summary Delete user avatar
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAvatar(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserAvatar(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.deleteUserAvatar']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserById(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.deleteUserById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyById(userId, keyId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApiKeyById(userId, keyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getApiKeyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get information about the currently authenticated user
         * @summary Get current user
         * @param {Array<UserIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(include, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentUser(include, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getCurrentUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountMembership(accountId, userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserAccountMembership(accountId, userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getUserAccountMembership']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets the user avatar, if the image is hosted on the Digiseg platform. Refer to the user\'s `avatar_url` to get a non-authenticated and shareable URL for the avatar.
         * @summary Get user avatar
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAvatar(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserAvatar(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getUserAvatar']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get user
         * @param {string} userId
         * @param {Array<UserIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId, include, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserById(userId, include, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getUserById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List API keys for user
         * @param {string} userId
         * @param {string} [filterAccountId] Filter by specific account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByUserId(userId, filterAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listApiKeysByUserId(userId, filterAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.listApiKeysByUserId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List users
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. &#x60;super_admin&#x60;
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterAccountId] Filter based on the user\&#39;s account
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.listUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List users for account
         * @param {string} accountId
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. super_admin
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.listUsersByAccountId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Removes a user from the referenced account.
         * @summary Remove user from account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromAccount(accountId, userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeUserFromAccount(accountId, userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.removeUserFromAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update API key
         * @param {string} userId
         * @param {string} keyId
         * @param {ApiKeyMutation} apiKeyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyById(userId, keyId, apiKeyMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApiKeyById(userId, keyId, apiKeyMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.updateApiKeyById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {UserAccountMembershipUpdate} userAccountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.updateUserAccountMembership']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update user
         * @param {string} userId
         * @param {UserMutation} userMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserById(userId, userMutation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserById(userId, userMutation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.updateUserById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Upload a avatar for a user
         * @summary Upload user avatar
         * @param {string} userId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserAvatar(userId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadUserAvatar(userId, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.uploadUserAvatar']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         * Adds a user to the referenced account.
         * @summary Add user to account
         * @param {string} accountId
         * @param {AccountUserAddition} accountUserAddition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToAccount(accountId, accountUserAddition, options) {
            return localVarFp.addUserToAccount(accountId, accountUserAddition, options).then((request) => request(axios, basePath));
        },
        /**
         * Create API key for the given user. When an API key is created, the `token` value will be exposed in the response. This token can be passed as the `X-API-KEY` header value for future requests. It is not obtainable in other API requests (ie. the client must decide how to keep the API key token in e.g. a vault or similar).
         * @summary Create API key
         * @param {string} userId
         * @param {ApiKeyCreation} apiKeyCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey(userId, apiKeyCreation, options) {
            return localVarFp.createApiKey(userId, apiKeyCreation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create user
         * @param {UserCreation} userCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreation, options) {
            return localVarFp.createUser(userCreation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyById(userId, keyId, options) {
            return localVarFp.deleteApiKeyById(userId, keyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the avatar for a user
         * @summary Delete user avatar
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAvatar(userId, options) {
            return localVarFp.deleteUserAvatar(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(userId, options) {
            return localVarFp.deleteUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get API key
         * @param {string} userId
         * @param {string} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeyById(userId, keyId, options) {
            return localVarFp.getApiKeyById(userId, keyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information about the currently authenticated user
         * @summary Get current user
         * @param {Array<UserIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(include, options) {
            return localVarFp.getCurrentUser(include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountMembership(accountId, userId, options) {
            return localVarFp.getUserAccountMembership(accountId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the user avatar, if the image is hosted on the Digiseg platform. Refer to the user\'s `avatar_url` to get a non-authenticated and shareable URL for the avatar.
         * @summary Get user avatar
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAvatar(userId, options) {
            return localVarFp.getUserAvatar(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get user
         * @param {string} userId
         * @param {Array<UserIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId, include, options) {
            return localVarFp.getUserById(userId, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List API keys for user
         * @param {string} userId
         * @param {string} [filterAccountId] Filter by specific account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeysByUserId(userId, filterAccountId, options) {
            return localVarFp.listApiKeysByUserId(userId, filterAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List users
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. &#x60;super_admin&#x60;
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterAccountId] Filter based on the user\&#39;s account
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options) {
            return localVarFp.listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List users for account
         * @param {string} accountId
         * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. super_admin
         * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
         * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
         * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
         * @param {number} [pageSize] The desired page size
         * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options) {
            return localVarFp.listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a user from the referenced account.
         * @summary Remove user from account
         * @param {string} accountId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromAccount(accountId, userId, options) {
            return localVarFp.removeUserFromAccount(accountId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update API key
         * @param {string} userId
         * @param {string} keyId
         * @param {ApiKeyMutation} apiKeyMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeyById(userId, keyId, apiKeyMutation, options) {
            return localVarFp.updateApiKeyById(userId, keyId, apiKeyMutation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a user\'s membership with an account
         * @param {string} accountId
         * @param {string} userId
         * @param {UserAccountMembershipUpdate} userAccountMembershipUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options) {
            return localVarFp.updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user
         * @param {string} userId
         * @param {UserMutation} userMutation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserById(userId, userMutation, options) {
            return localVarFp.updateUserById(userId, userMutation, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a avatar for a user
         * @summary Upload user avatar
         * @param {string} userId
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserAvatar(userId, body, options) {
            return localVarFp.uploadUserAvatar(userId, body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Adds a user to the referenced account.
     * @summary Add user to account
     * @param {string} accountId
     * @param {AccountUserAddition} accountUserAddition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    addUserToAccount(accountId, accountUserAddition, options) {
        return UsersApiFp(this.configuration).addUserToAccount(accountId, accountUserAddition, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create API key for the given user. When an API key is created, the `token` value will be exposed in the response. This token can be passed as the `X-API-KEY` header value for future requests. It is not obtainable in other API requests (ie. the client must decide how to keep the API key token in e.g. a vault or similar).
     * @summary Create API key
     * @param {string} userId
     * @param {ApiKeyCreation} apiKeyCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createApiKey(userId, apiKeyCreation, options) {
        return UsersApiFp(this.configuration).createApiKey(userId, apiKeyCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create user
     * @param {UserCreation} userCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createUser(userCreation, options) {
        return UsersApiFp(this.configuration).createUser(userCreation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete API key
     * @param {string} userId
     * @param {string} keyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteApiKeyById(userId, keyId, options) {
        return UsersApiFp(this.configuration).deleteApiKeyById(userId, keyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the avatar for a user
     * @summary Delete user avatar
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteUserAvatar(userId, options) {
        return UsersApiFp(this.configuration).deleteUserAvatar(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete user
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteUserById(userId, options) {
        return UsersApiFp(this.configuration).deleteUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get API key
     * @param {string} userId
     * @param {string} keyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getApiKeyById(userId, keyId, options) {
        return UsersApiFp(this.configuration).getApiKeyById(userId, keyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get information about the currently authenticated user
     * @summary Get current user
     * @param {Array<UserIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getCurrentUser(include, options) {
        return UsersApiFp(this.configuration).getCurrentUser(include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a user\'s membership with an account
     * @param {string} accountId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUserAccountMembership(accountId, userId, options) {
        return UsersApiFp(this.configuration).getUserAccountMembership(accountId, userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the user avatar, if the image is hosted on the Digiseg platform. Refer to the user\'s `avatar_url` to get a non-authenticated and shareable URL for the avatar.
     * @summary Get user avatar
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUserAvatar(userId, options) {
        return UsersApiFp(this.configuration).getUserAvatar(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get user
     * @param {string} userId
     * @param {Array<UserIncludeParam>} [include] Optional parameter used to define aux properties to load in the response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUserById(userId, include, options) {
        return UsersApiFp(this.configuration).getUserById(userId, include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List API keys for user
     * @param {string} userId
     * @param {string} [filterAccountId] Filter by specific account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    listApiKeysByUserId(userId, filterAccountId, options) {
        return UsersApiFp(this.configuration).listApiKeysByUserId(userId, filterAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List users
     * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. &#x60;super_admin&#x60;
     * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
     * @param {string} [filterAccountId] Filter based on the user\&#39;s account
     * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
     * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options) {
        return UsersApiFp(this.configuration).listUsers(filterPlatformRoles, filterAccountRoles, filterAccountId, filterNameContains, sort, pageSize, pageAfter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List users for account
     * @param {string} accountId
     * @param {UserPlatformRole} [filterPlatformRoles] Filter based on platform roles, e.g. super_admin
     * @param {UserAccountRole} [filterAccountRoles] Filter based on account roles, e.g. &#x60;owner&#x60;
     * @param {string} [filterNameContains] Optional parameter used to search for users where the name contains a substring (case insensitive)
     * @param {UserSortOption} [sort] Defines the field to sort the result items by. Ascending order is applied by default, but the minus character can be used to indicate descending order instead.
     * @param {number} [pageSize] The desired page size
     * @param {string} [pageAfter] Optional pagination parameter, indicating the previous cursor value to paginate beyond. The value to provide here is opaque, but can be found in previous requests in the &#x60;meta.page.last_cursor&#x60; field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options) {
        return UsersApiFp(this.configuration).listUsersByAccountId(accountId, filterPlatformRoles, filterAccountRoles, filterNameContains, sort, pageSize, pageAfter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removes a user from the referenced account.
     * @summary Remove user from account
     * @param {string} accountId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    removeUserFromAccount(accountId, userId, options) {
        return UsersApiFp(this.configuration).removeUserFromAccount(accountId, userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update API key
     * @param {string} userId
     * @param {string} keyId
     * @param {ApiKeyMutation} apiKeyMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    updateApiKeyById(userId, keyId, apiKeyMutation, options) {
        return UsersApiFp(this.configuration).updateApiKeyById(userId, keyId, apiKeyMutation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a user\'s membership with an account
     * @param {string} accountId
     * @param {string} userId
     * @param {UserAccountMembershipUpdate} userAccountMembershipUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options) {
        return UsersApiFp(this.configuration).updateUserAccountMembership(accountId, userId, userAccountMembershipUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update user
     * @param {string} userId
     * @param {UserMutation} userMutation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    updateUserById(userId, userMutation, options) {
        return UsersApiFp(this.configuration).updateUserById(userId, userMutation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload a avatar for a user
     * @summary Upload user avatar
     * @param {string} userId
     * @param {File} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    uploadUserAvatar(userId, body, options) {
        return UsersApiFp(this.configuration).uploadUserAvatar(userId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UxApi - axios parameter creator
 * @export
 */
export const UxApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingData: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/ux/user/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingData: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/ux/user/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Save key-value data for user onboarding
         * @param {{ [key: string]: string; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingData: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('saveOnboardingData', 'requestBody', requestBody);
            const localVarPath = `/ux/user/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oAuth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "oAuth", [], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication apiKeyHeaderAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration);
            // authentication apiKeyQueryParamAuth required
            yield setApiKeyToObject(localVarQueryParameter, "api_key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UxApi - functional programming interface
 * @export
 */
export const UxApiFp = function (configuration) {
    const localVarAxiosParamCreator = UxApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingData(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOnboardingData(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UxApi.deleteOnboardingData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingData(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOnboardingData(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UxApi.getOnboardingData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Save key-value data for user onboarding
         * @param {{ [key: string]: string; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingData(requestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveOnboardingData(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UxApi.saveOnboardingData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * UxApi - factory interface
 * @export
 */
export const UxApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UxApiFp(configuration);
    return {
        /**
         *
         * @summary Delete key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingData(options) {
            return localVarFp.deleteOnboardingData(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get key-value data for user onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingData(options) {
            return localVarFp.getOnboardingData(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Save key-value data for user onboarding
         * @param {{ [key: string]: string; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingData(requestBody, options) {
            return localVarFp.saveOnboardingData(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UxApi - object-oriented interface
 * @export
 * @class UxApi
 * @extends {BaseAPI}
 */
export class UxApi extends BaseAPI {
    /**
     *
     * @summary Delete key-value data for user onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UxApi
     */
    deleteOnboardingData(options) {
        return UxApiFp(this.configuration).deleteOnboardingData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get key-value data for user onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UxApi
     */
    getOnboardingData(options) {
        return UxApiFp(this.configuration).getOnboardingData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Save key-value data for user onboarding
     * @param {{ [key: string]: string; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UxApi
     */
    saveOnboardingData(requestBody, options) {
        return UxApiFp(this.configuration).saveOnboardingData(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
